import React from 'react';
import EylulGerceklesen from './EylulGerceklesen';

/* ═══════════════════════════════════════════════════════════════════════════
   HUPALUPA STORE — EYLÜL 2026 MEDYA PLANI                    ₺1.310.000
   ---------------------------------------------------------------------------
   Ağustos planından (/budget/hupalupa-store-agustos-2026) iki farkı var:

   1) Bütçe TEK KALEM değil. Store'un genel bütçesi (₺400.000) ile mağazanın
      içindeki altı markanın bütçesi AYRI AYRI yönetiliyor. Her markanın kendi
      kampanya tablosu, kendi birim maliyeti ve kendi gerekçesi var.
   2) Bütün birim maliyetler Ağustos 2026'nın GERÇEKLEŞEN verisinden geliyor
      (Google 9 kampanya + Meta 16 kampanya, 1 Eylül'de hesaptan çekildi).
      Hesapta karşılığı olmayan satırlar (TikTok, video izlenme) benchmark
      olarak işaretli.

   🔑 Sayıların tamamı aşağıdaki PLAN dizisinden TÜRETİLİYOR — tabloya elle
      yazılmış tek bir toplam yok. Bütçeyi değiştirmek için yalnızca `butce`
      alanını değiştir, çıktı ve yüzdeler kendiliğinden güncellenir.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Kampanya amacı rozeti (Ağustos planıyla aynı renk kodu) ─────────────── */
const AMAC_STIL = {
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
};

function Amac({ tip }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}
    </span>
  );
}

/* ── Mecra kimlikleri ────────────────────────────────────────────────────── */
const MECRA = {
  google: { ad: 'Google Ads', logo: '/google_ads-512.webp', satir: 'bg-blue-50 text-blue-800' },
  meta:   { ad: 'Meta Ads',   logo: '/6033716.png',          satir: 'bg-indigo-50 text-indigo-800' },
  tiktok: { ad: 'TikTok Ads', logo: '/tiktokv4.svg',         satir: 'bg-gray-100 text-gray-800' },
};

/* ── Marka kimlikleri ────────────────────────────────────────────────────────
   Renkler doğrulanmış kategorik paletin 1-7. slotları, bütçeye göre AZALAN
   sırada. Bu sıra tesadüf değil: palet tam bu komşuluk sırasıyla renk körlüğü
   testinden geçiyor (en kötü komşu çifti ΔE 9,1). Sırayı değiştirirsen testi
   yeniden çalıştır. Üç renk açık zeminde 3:1 kontrastın altında kaldığı için
   şeridin hemen altında okunur bir tablo var — renk tek başına bilgi taşımıyor.
   ------------------------------------------------------------------------- */
const MARKALAR = [
  { key: 'needoh',    ad: 'NeeDoh',          logo: '/logos/markalar/needoh.svg',      renk: '#2a78d6', agustos: 0,     urun: 0,  sepet: null, arama: 49500 },
  { key: 'store',     ad: 'HUPALUPA Store',  logo: '/logos/grup/hupalupa-store.svg',  renk: '#eb6834', agustos: 434268, urun: 4329, sepet: null, arama: 33100 },
  { key: 'playmobil', ad: 'Playmobil',       logo: '/logos/markalar/playmobil.svg',   renk: '#1baf7a', agustos: 19283, urun: 65, sepet: 2361, arama: 3600 },
  { key: 'charmit',   ad: 'Charm It',        logo: '/logos/markalar/charmit.png',     renk: '#eda100', agustos: 3127,  urun: 51, sepet: 662,  arama: 70 },
  { key: 'xmud',      ad: 'X Mud',           logo: '/logos/markalar/xmud.png',        renk: '#e87ba4', agustos: 0,     urun: 14, sepet: 750,  arama: 10 },
  { key: 'antonio',   ad: 'Antonio Juan',    logo: '/logos/markalar/antoniojuan.svg', renk: '#008300', agustos: 0,     urun: 28, sepet: 5504, arama: 140 },
  { key: 'zoo',       ad: 'Zoo Family',      logo: '/logos/markalar/zoofamily.svg',   renk: '#4a3aa7', agustos: 0,     urun: 13, sepet: 3386, arama: 90 },
];

/* ── PLAN ────────────────────────────────────────────────────────────────────
   `cpc` / `cpm` / `cpv` alanları çıktının kaynağı. `kaynak: 'gercek'` olan
   satırların birim maliyeti Ağustos 2026'da o hesapta GERÇEKLEŞEN değerdir;
   `kaynak: 'benchmark'` olanlar hesapta karşılığı olmadığı için pazar
   ortalamasıdır. `sart: true` olan satırlar ürün feed'ine bağlı — feed
   düzelmezse o satır YAYINA ALINAMAZ (aşağıdaki Ön Koşullar bölümüne bak).
   ------------------------------------------------------------------------- */
const PLAN = [
  /* ─────────────── HUPALUPA STORE — GENEL ₺400.000 ─────────────── */
  { marka: 'store', mecra: 'google', kampanya: 'Performance Max — Genel Katalog', kitle: 'Geniş + alışveriş sinyalli · 25-45 ebeveyn', amac: 'Dönüşüm', butce: 85000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'store', mecra: 'google', kampanya: 'Search — Branding', kitle: 'Markayı adıyla arayanlar (hupalupa / hupalupa.store)', amac: 'Dönüşüm', butce: 25000, cpc: 3.95, cpm: 343, kaynak: 'gercek' },
  { marka: 'store', mecra: 'google', kampanya: 'Search — Generic (okul dönemi)', kitle: '"kırtasiye", "beslenme çantası", "puzzle" arayanlar', amac: 'Dönüşüm', butce: 25000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'store', mecra: 'google', kampanya: 'Dynamic Search Ads (DSA)', kitle: 'Site içeriğiyle eşleşen uzun kuyruk aramalar', amac: 'Dönüşüm', butce: 30000, cpc: 6.92, cpm: 490, kaynak: 'gercek' },
  { marka: 'store', mecra: 'google', kampanya: 'Shopping — All Products', kitle: 'Ürün adı / kategori arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 5000, cpc: 1.09, cpm: 30, kaynak: 'gercek' },
  { marka: 'store', mecra: 'google', kampanya: 'YouTube — Marka filmi', kitle: '25-45 ebeveyn · aile ve çocuk içeriği izleyicileri', amac: 'Farkındalık', butce: 5000, cpv: 0.12, cpm: 33.5, kaynak: 'benchmark' },
  { marka: 'store', mecra: 'meta', kampanya: 'Advantage+ Catalog', kitle: 'Geniş prospecting · katalog satın alma sinyali', amac: 'Dönüşüm', butce: 90000, cpc: 3.15, cpm: 152, kaynak: 'gercek' },
  { marka: 'store', mecra: 'meta', kampanya: 'Catalog — Yeni Kullanıcı (NU)', kitle: 'Siteyle hiç temas etmemiş yeni kullanıcı havuzu', amac: 'Dönüşüm', butce: 30000, cpc: 2.86, cpm: 202, kaynak: 'gercek' },
  { marka: 'store', mecra: 'meta', kampanya: 'Catalog Remarketing (kategori + ürün)', kitle: 'Son 30 gün ürün gören / sepete ekleyen / satın almayan', amac: 'Dönüşüm', butce: 35000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },
  { marka: 'store', mecra: 'meta', kampanya: 'Sales — Statik', kitle: 'Okul dönemi ilgi alanları · Lookalike %1-3 (satın alanlar)', amac: 'Dönüşüm', butce: 20000, cpc: 8.90, cpm: 256, kaynak: 'gercek' },
  { marka: 'store', mecra: 'meta', kampanya: 'Post Engagement', kitle: 'Geniş ebeveyn kitlesi + sayfa etkileşimcileri', amac: 'Etkileşim', butce: 20000, cpm: 32, kaynak: 'gercek' },
  { marka: 'store', mecra: 'meta', kampanya: 'Video Views', kitle: 'Geniş prospecting 25-45 · çocuk ve aile ilgi alanları', amac: 'Farkındalık', butce: 10000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },
  { marka: 'store', mecra: 'tiktok', kampanya: 'Awareness', kitle: '25-45 ebeveyn · geniş bölgesel erişim', amac: 'Farkındalık', butce: 8000, cpm: 12, kaynak: 'benchmark' },
  { marka: 'store', mecra: 'tiktok', kampanya: 'Engagement', kitle: 'Oyuncak ve çocuk ürünleri içeriği izleyicileri', amac: 'Etkileşim', butce: 6000, cpm: 30, kaynak: 'benchmark' },
  { marka: 'store', mecra: 'tiktok', kampanya: 'Video Views', kitle: '25-45 ebeveyn · oyuncak içeriği izleyicileri', amac: 'Farkındalık', butce: 6000, cpv: 0.06, cpm: 25, kaynak: 'benchmark' },

  /* ─────────────── NEEDOH ₺600.000 ─────────────── */
  { marka: 'needoh', mecra: 'google', kampanya: 'Search — NeeDoh Marka', kitle: '"needoh", "nee doh", "needoh nice cube" arayanlar', amac: 'Dönüşüm', butce: 60000, cpc: 4.50, cpm: 340, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'google', kampanya: 'Search — Kategori', kitle: '"stres oyuncağı", "squishy oyuncak", "fidget oyuncak"', amac: 'Dönüşüm', butce: 45000, cpc: 6.00, cpm: 420, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'google', kampanya: 'Performance Max — NeeDoh ürün grubu', kitle: 'Geniş + alışveriş sinyalli · NeeDoh asset grubu', amac: 'Dönüşüm', butce: 75000, cpc: 7.69, cpm: 142, kaynak: 'gercek', sart: true },
  { marka: 'needoh', mecra: 'google', kampanya: 'YouTube — NeeDoh tanıtım', kitle: '13-35 · fidget, ASMR, oyuncak içeriği izleyicileri', amac: 'Farkındalık', butce: 30000, cpv: 0.12, cpm: 33.5, kaynak: 'benchmark' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Advantage+ Catalog — NeeDoh', kitle: 'Geniş prospecting · NeeDoh katalog seti', amac: 'Dönüşüm', butce: 120000, cpc: 3.15, cpm: 152, kaynak: 'gercek', sart: true },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Sales — Lansman kreatifleri', kitle: 'Fidget/duyusal oyuncak ilgi alanları · Lookalike %1-3', amac: 'Dönüşüm', butce: 80000, cpc: 9.00, cpm: 280, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'NeeDoh ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 40000, cpc: 2.53, cpm: 163, kaynak: 'gercek', sart: true },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Video Views — squish filmi', kitle: 'Geniş prospecting · ASMR ve duyusal içerik izleyicileri', amac: 'Farkındalık', butce: 60000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Post Engagement', kitle: 'Geniş 13-35 + reklam etkileşimcileri', amac: 'Etkileşim', butce: 30000, cpm: 32, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'tiktok', kampanya: 'Video Views', kitle: 'Fidget/squish içeriği izleyicileri · geniş 13-35', amac: 'Farkındalık', butce: 30000, cpv: 0.06, cpm: 25, kaynak: 'benchmark' },
  { marka: 'needoh', mecra: 'tiktok', kampanya: 'Engagement', kitle: 'Video izleyenler + hashtag etkileşimcileri', amac: 'Etkileşim', butce: 20000, cpm: 30, kaynak: 'benchmark' },
  { marka: 'needoh', mecra: 'tiktok', kampanya: 'Awareness', kitle: 'Geniş bölgesel erişim · 13-35', amac: 'Farkındalık', butce: 10000, cpm: 12, kaynak: 'benchmark' },

  /* ─────────────── PLAYMOBIL ₺150.000 ─────────────── */
  { marka: 'playmobil', mecra: 'google', kampanya: 'Search — Playmobil Marka', kitle: '"playmobil" ve ürün kodu arayanlar', amac: 'Dönüşüm', butce: 8000, cpc: 4.00, cpm: 340, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'google', kampanya: 'Search — Generic', kitle: '"yapı oyuncakları", "oyun seti", "figür oyuncak"', amac: 'Dönüşüm', butce: 15000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'google', kampanya: 'Performance Max — Playmobil ürün grubu', kitle: 'Geniş + alışveriş sinyalli · Playmobil asset grubu', amac: 'Dönüşüm', butce: 30000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'google', kampanya: 'YouTube — Koleksiyon filmi', kitle: '25-45 ebeveyn · oyuncak inceleme izleyicileri', amac: 'Farkındalık', butce: 7000, cpv: 0.12, cpm: 33.5, kaynak: 'benchmark' },
  { marka: 'playmobil', mecra: 'meta', kampanya: 'Advantage+ Catalog — Playmobil', kitle: 'Geniş prospecting · Playmobil katalog seti', amac: 'Dönüşüm', butce: 45000, cpc: 7.00, cpm: 260, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'meta', kampanya: 'Sales — Statik / Video', kitle: 'Yapı oyuncağı ilgi alanları · Lookalike %1-3', amac: 'Dönüşüm', butce: 25000, cpc: 9.00, cpm: 280, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Playmobil ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 20000, cpc: 4.00, cpm: 200, kaynak: 'gercek' },

  /* ─────────────── CHARM IT ₺50.000 ─────────────── */
  { marka: 'charmit', mecra: 'google', kampanya: 'Shopping / PMax — Charm It ürün grubu', kitle: 'Takı ve aksesuar arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 8000, cpc: 2.50, cpm: 60, kaynak: 'gercek' },
  { marka: 'charmit', mecra: 'meta', kampanya: 'Advantage+ Catalog — Charm It', kitle: 'Geniş prospecting · Charm It katalog seti', amac: 'Dönüşüm', butce: 20000, cpc: 7.00, cpm: 260, kaynak: 'gercek' },
  { marka: 'charmit', mecra: 'meta', kampanya: 'Sales — Koleksiyon anlatımı', kitle: '8-14 kız çocuk ebeveyni · takı ve hediye ilgi alanları', amac: 'Dönüşüm', butce: 14000, cpc: 9.00, cpm: 280, kaynak: 'gercek' },
  { marka: 'charmit', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Charm It ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 8000, cpc: 4.00, cpm: 200, kaynak: 'gercek' },

  /* ─────────────── X MUD ₺40.000 ─────────────── */
  { marka: 'xmud', mecra: 'google', kampanya: 'Search — Generic (slime)', kitle: '"slime", "slime seti", "hazır slime" arayanlar', amac: 'Dönüşüm', butce: 9000, cpc: 5.00, cpm: 380, kaynak: 'gercek' },
  { marka: 'xmud', mecra: 'google', kampanya: 'Shopping — X Mud', kitle: 'Slime ve oyun hamuru arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 6000, cpc: 2.00, cpm: 55, kaynak: 'gercek' },
  { marka: 'xmud', mecra: 'meta', kampanya: 'Advantage+ Catalog — X Mud', kitle: 'Geniş prospecting · X Mud katalog seti', amac: 'Dönüşüm', butce: 8000, cpc: 6.00, cpm: 240, kaynak: 'gercek' },
  { marka: 'xmud', mecra: 'meta', kampanya: 'Video Views — slime içeriği', kitle: '7-16 ve ebeveyni · slime ve DIY içerik izleyicileri', amac: 'Farkındalık', butce: 7000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },
  { marka: 'xmud', mecra: 'tiktok', kampanya: 'Video Views', kitle: 'Slime ve ASMR içeriği izleyicileri', amac: 'Farkındalık', butce: 10000, cpv: 0.06, cpm: 25, kaynak: 'benchmark' },

  /* ─────────────── ANTONIO JUAN ₺40.000 ─────────────── */
  { marka: 'antonio', mecra: 'google', kampanya: 'Search — Marka + Generic', kitle: '"antonio juan", "et bebek", "oyuncak bebek" arayanlar', amac: 'Dönüşüm', butce: 12000, cpc: 6.30, cpm: 730, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'google', kampanya: 'Shopping — Antonio Juan', kitle: 'Oyuncak bebek arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 6000, cpc: 2.50, cpm: 60, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'meta', kampanya: 'Advantage+ Catalog — Antonio Juan', kitle: 'Geniş prospecting · Antonio Juan katalog seti', amac: 'Dönüşüm', butce: 12000, cpc: 7.00, cpm: 260, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'meta', kampanya: 'Sales — Statik (yüksek sepet)', kitle: 'Hediye ve koleksiyon ilgi alanları · Lookalike %1-3', amac: 'Dönüşüm', butce: 6000, cpc: 9.00, cpm: 280, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Antonio Juan ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 4000, cpc: 4.00, cpm: 200, kaynak: 'gercek' },

  /* ─────────────── ZOO FAMILY ₺30.000 ─────────────── */
  { marka: 'zoo', mecra: 'google', kampanya: 'Search — Generic', kitle: '"çocuk fotoğraf makinesi", "anında baskı kamera"', amac: 'Dönüşüm', butce: 7000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'google', kampanya: 'Shopping — Zoo Family', kitle: 'Çocuk elektroniği arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 5000, cpc: 2.50, cpm: 60, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'meta', kampanya: 'Advantage+ Catalog — Zoo Family', kitle: 'Geniş prospecting · Zoo Family katalog seti', amac: 'Dönüşüm', butce: 6000, cpc: 7.00, cpm: 260, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'meta', kampanya: 'Video Views — ürün demo', kitle: 'Hediye arayan ebeveyn · teknoloji ve fotoğraf ilgi alanları', amac: 'Farkındalık', butce: 7000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },
  { marka: 'zoo', mecra: 'tiktok', kampanya: 'Video Views', kitle: 'Çocuk teknolojisi ve hediye içeriği izleyicileri', amac: 'Farkındalık', butce: 5000, cpv: 0.06, cpm: 25, kaynak: 'benchmark' },
];

/* ── Ağustos 2026 GERÇEKLEŞEN (1 Eylül'de hesaptan çekildi, tam ay) ──────── */
const AGUSTOS = {
  google: { harcama: 182463, gosterim: 1097932, tik: 28523, cpc: 6.40, cpm: 166, donusum: 155.4, ciro: 834254, roas: 4.57 },
  meta:   { harcama: 274215, gosterim: 2792746, tik: 69265, cpc: 3.96, cpm: 98,  donusum: 188,   ciro: 688657, roas: 2.51 },
  tiktok: { harcama: 0,      gosterim: 0,       tik: 0,     cpc: 0,    cpm: 0,   donusum: 0,     ciro: 0,      roas: 0 },
};
const AGUSTOS_TOPLAM = {
  harcama: 456678, gosterim: 3890678, tik: 97788, cpc: 4.67, cpm: 117, donusum: 343.4, ciro: 1522911, roas: 3.34,
};

/* ── NeeDoh marka talebi — Türkiye, aylık arama (Keyword Planner, GOOGLE_SEARCH)
   Sunumun omurgası bu seri. 24 ay, tek kelime: "needoh".                    */
const NEEDOH_SERI = [
  { y: 2024, a: 8, v: 140 }, { y: 2024, a: 9, v: 140 }, { y: 2024, a: 10, v: 110 }, { y: 2024, a: 11, v: 170 },
  { y: 2024, a: 12, v: 390 }, { y: 2025, a: 1, v: 320 }, { y: 2025, a: 2, v: 320 }, { y: 2025, a: 3, v: 880 },
  { y: 2025, a: 4, v: 320 }, { y: 2025, a: 5, v: 320 }, { y: 2025, a: 6, v: 210 }, { y: 2025, a: 7, v: 320 },
  { y: 2025, a: 8, v: 260 }, { y: 2025, a: 9, v: 210 }, { y: 2025, a: 10, v: 320 }, { y: 2025, a: 11, v: 720 },
  { y: 2025, a: 12, v: 1300 }, { y: 2026, a: 1, v: 1900 }, { y: 2026, a: 2, v: 6600 }, { y: 2026, a: 3, v: 18100 },
  { y: 2026, a: 4, v: 22200 }, { y: 2026, a: 5, v: 33100 }, { y: 2026, a: 6, v: 40500 }, { y: 2026, a: 7, v: 49500 },
];
const AY_KISA = { 1: 'Oca', 2: 'Şub', 3: 'Mar', 4: 'Nis', 5: 'May', 6: 'Haz', 7: 'Tem', 8: 'Ağu', 9: 'Eyl', 10: 'Eki', 11: 'Kas', 12: 'Ara' };

/* ── Eylül mevsimselliği — Ağustos→Eylül, iki yıl (Keyword Planner) ─────── */
const MEVSIM_STORE = [
  { kw: 'kırtasiye',           a25: 550000, e25: 673000,  a24: 823000, e24: 1000000 },
  { kw: 'beslenme çantası',    a25: 40500,  e25: 74000,   a24: 60500,  e24: 110000 },
  { kw: 'puzzle',              a25: 27100,  e25: 33100,   a24: 27100,  e24: 27100 },
  { kw: 'oyuncak',             a25: 110000, e25: 90500,   a24: 135000, e24: 110000 },
  { kw: 'lego',                a25: 301000, e25: 246000,  a24: 246000, e24: 246000 },
  { kw: 'okul çantası',        a25: 246000, e25: 135000,  a24: 450000, e24: 246000 },
];
const MEVSIM_NEEDOH = [
  { kw: 'stres oyuncağı',      a25: 2900,   e25: 3600,    a24: 2900,   e24: 3600 },
  { kw: 'fidget oyuncak',      a25: 390,    e25: 480,     a24: 210,    e24: 210 },
  { kw: 'squishy oyuncak',     a25: 2400,   e25: 2900,    a24: 1900,   e24: 2400 },
  { kw: 'pop it',              a25: 8100,   e25: 6600,    a24: 9900,   e24: 8100 },
];

/* ── Ağustos'ta marka bazına ayrılmış kampanyaların gerçekleşen verisi ───── */
const MARKA_IZOLE = [
  { ad: 'Katalog motoru (marka ayrımsız)', harcama: 182867, cpc: '2,49 - 3,15', cpm: '81 - 202', roas: '3,27 - 9,66', iyi: true },
  { ad: 'Katalog satış, Playmobil', harcama: 19283, cpc: '10,74', cpm: '327', roas: '1,42', iyi: false },
  { ad: 'Dönüşüm, MODU', harcama: 9793, cpc: '14,57', cpm: '468', roas: '0,31', iyi: false },
  { ad: 'Dönüşüm, Charm It', harcama: 3127, cpc: '11,29', cpm: '338', roas: '1,11', iyi: false },
];

/* ═══════════════════════════════════════════════════════════════════════════
   CİRO RÖNTGENİ — GA4 ürün performansı, 1 Mart – 31 Ağustos 2026 (6 tam ay)
   ---------------------------------------------------------------------------
   Kaynak: GA4 property 364875770 (HUPALUPA Store), Data API `runReport`,
   boyutlar itemBrand × itemCategory × yearMonth, metrik itemRevenue.
   3 Eylül 2026'da çekildi. Property'deki purchaseRevenue ile itemRevenue
   aynı (₺8.572.056) — yani bu tablo sitenin TOPLAM cirosunun tamamını
   kapsıyor, bir dilimini değil.

   🔑 İKİ TANIM KURALI (rakamları okurken bunlar geçerli):
   1) "Okul Setleri / B2S" = GA4'te `Kırtasiye Ürünleri` ana kategorisinin
      tamamı (çanta ve kalem kutusu, suluk-termos, beslenme çantası, jel
      kalem, sticker, aktivite seti, defter…). GA4 kategori ağacında
      "okul seti" diye tek bir kategori YOK; en yakın karşılık bu.
   2) ÇAKIŞMA → MARKA ÖNCELİKLİ. Smiggle cirosunun %99'u kırtasiye
      kategorisinde. Kendi satırında sayılır, B2S satırından DÜŞÜLÜR.
      Böylece 11 satırın toplamı = ₺8.572.056, yani hiçbir kuruş iki kez
      sayılmaz ve "Diğer" gerçekten geri kalan olur.

   🔑 Bu blokta TEK renk (mavi) kullanılıyor — buradaki renk kimlik değil
      BÜYÜKLÜK taşıyor. Yukarıdaki plan bölümlerinin marka renkleri burada
      bilerek tekrarlanmadı; aynı hex'in bir yerde "NeeDoh", başka yerde
      "9 markanın toplamı" demesi tabloyu okunmaz yapardı.
   ═══════════════════════════════════════════════════════════════════════════ */
const CIRO_AYLAR = ['Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu'];

/* Eylül planındaki marka bütçesiyle eşleşme: MARKALAR[].key ya da null.
   null = bu markanın ayrı bütçesi yok, Store'un genel ₺400.000'inden beslenir. */
/* 🔑 `ciro` alanı YOK, bilerek: 6 aylık toplam `ay` dizisinden TÜRETİLİYOR.
   İki tablo (üstteki özet + aylık kırılım) aynı sayıyı iki kere yazsaydı,
   aylık değerler tam liraya yuvarlı olduğu için satır toplamı ile ayların
   toplamı 1-3 ₺ ayrışıyordu ve aynı sayfada iki farklı rakam görünüyordu.
   Yeni bir dönem yapıştırırken de yalnız `ay` doğru olsun yeter. */
const ayTopla = (r) => ({ ...r, ciro: r.ay.reduce((a, v) => a + v, 0) });

const CIRO = [
  { key: 'zoofamily',   ad: 'Zoo Family',   plan: 'zoo',       adet: 164,  goruntulenme: 16899,  ay: [41500, 164516, 150555, 77520, 57727, 20683] },
  { key: 'antoniojuan', ad: 'Antonio Juan', plan: 'antonio',   adet: 75,   goruntulenme: 15194,  ay: [19278, 39834, 57478, 44641, 77021, 93848] },
  { key: 'modu',        ad: 'Modu',         plan: null,        adet: 23,   goruntulenme: 15525,  ay: [45800, 66335, 32157, 11900, 112970, 44655] },
  { key: 'smiggle',     ad: 'Smiggle',      plan: null,        adet: 29,   goruntulenme: 8752,   ay: [4950, 2350, 6670, 1187, 0, 98152] },
  { key: 'meli',        ad: 'Meli',         plan: null,        adet: 53,   goruntulenme: 4649,   ay: [3417, 28837, 17253, 6696, 4722, 3196] },
  { key: 'playmobil',   ad: 'Playmobil',    plan: 'playmobil', adet: 76,   goruntulenme: 7815,   ay: [1200, 0, 2112, 6199, 16881, 29388] },
  { key: 'charmit',     ad: 'Charm It',     plan: 'charmit',   adet: 11,   goruntulenme: 1159,   ay: [0, 770, 0, 0, 1050, 6109] },
  { key: 'xmud',        ad: 'X Mud',        plan: 'xmud',      adet: 7,    goruntulenme: 982,    ay: [0, 0, 0, 0, 0, 5250] },
  { key: 'needoh',      ad: 'NeeDoh',       plan: 'needoh',    adet: 0,    goruntulenme: 0,      ay: [0, 0, 0, 0, 0, 0] },
].map(ayTopla);
const CIRO_B2S   = ayTopla({ key: 'b2s',   ad: 'Okul Setleri / B2S', adet: 1135, goruntulenme: 123452, ay: [132808, 127558, 84379, 174636, 318287, 390492] });
const CIRO_DIGER = ayTopla({ key: 'diger', ad: 'Diğer',              adet: 4470, goruntulenme: 588494, ay: [806535, 924228, 1220377, 1375258, 894370, 718320] });
/* "Diğer"in içinde CİRO ÜRETEN marka sayısı. GA4'te 395 farklı itemBrand etiketi
   görünüyor ama 181'i dönemde tek kuruş satmadı (yalnız görüntülendi) — bu tablo
   ciro tablosu olduğu için satan marka sayısı yazılıyor. */
const CIRO_DIGER_MARKA_SAYISI = 214;
/* Dönemde en az bir kuruş satan marka etiketi sayısı (GA4 itemBrand, ciro > 0).
   Toplam 416 etiket görünüyor; 166'sı yalnız görüntülenmiş, satılmamış. */
const CIRO_TOPLAM_MARKA = 250;

/* "Diğer"in içindeki ilk 20 marka — planda hiçbirinin ayrı bütçesi yok. */
const DIGER_ILK20 = [
  { ad: 'Panini',         adet: 1994, ay: [4090, 3940, 76911, 357452, 128795, 13770] },
  { ad: 'Micro Scooter',  adet: 60,   ay: [8549, 50845, 251048, 52706, 88956, 129004] },
  { ad: 'Globber',        adet: 59,   ay: [43200, 51479, 150209, 112334, 66194, 12825] },
  { ad: 'Our Generation', adet: 68,   ay: [69614, 85819, 50547, 34197, 32838, 15553] },
  { ad: 'B Toys',         adet: 143,  ay: [51179, 43885, 28788, 71000, 65732, 23093] },
  { ad: 'Intex',          adet: 48,   ay: [0, 0, 11570, 127850, 79591, 49105] },
  { ad: 'Bestway',        adet: 23,   ay: [1140, 26568, 48805, 34090, 51240, 40950] },
  { ad: 'Funko',          adet: 135,  ay: [23321, 8546, 8905, 73557, 35332, 34661] },
  { ad: 'Magna Tiles',    adet: 49,   ay: [38701, 23313, 20919, 48210, 14012, 28619] },
  { ad: 'Airwheel',       adet: 6,    ay: [57190, 27625, 48750, 0, 0, 0] },
  { ad: 'Classic World',  adet: 45,   ay: [14336, 22509, 29815, 4082, 7645, 51142] },
  { ad: 'Bubble Wand',    adet: 123,  ay: [12096, 29921, 23784, 37715, 14821, 10926] },
  { ad: 'LEGO',           adet: 26,   ay: [13708, 45105, 54228, 628, 1606, 4097] },
  { ad: 'Martinelia',     adet: 73,   ay: [24415, 9216, 20239, 29555, 8101, 5468] },
  { ad: 'Bblüv',          adet: 33,   ay: [5439, 19274, 13618, 10446, 13796, 16162] },
  { ad: 'Quut',           adet: 57,   ay: [4268, 16391, 10547, 25418, 8327, 12182] },
  { ad: 'Loop Lasso',     adet: 48,   ay: [4482, 20642, 14773, 17372, 6926, 10286] },
  { ad: 'Mideer',         adet: 39,   ay: [2682, 18819, 28039, 16546, 4370, 1341] },
  { ad: 'Janod',          adet: 21,   ay: [9720, 20101, 4857, 30492, 2424, 3335] },
  { ad: 'Sunman',         adet: 73,   ay: [9845, 9742, 16609, 11237, 11087, 7171] },
].map((r, i) => ayTopla({ ...r, key: `d${i}` }));

/* Kırtasiye kategorisinin HAM aylık cirosu (Smiggle dahil) — B2S mevsimselliği.
   2025 sütunu Eylül'ün Ağustos'a oranını veriyor: 201.881 / 278.607 = 0,72. */
const B2S_MEVSIM = {
  y2025: [{ ay: 'Tem', v: 39477 }, { ay: 'Ağu', v: 278607 }, { ay: 'Eyl', v: 201881 }, { ay: 'Eki', v: 60648 }, { ay: 'Kas', v: 60069 }],
  y2026: [{ ay: 'Mar', v: 137758 }, { ay: 'Nis', v: 129908 }, { ay: 'May', v: 91048 }, { ay: 'Haz', v: 174636 }, { ay: 'Tem', v: 318287 }, { ay: 'Ağu', v: 488644 }],
};

/* ── Yardımcılar ─────────────────────────────────────────────────────────── */
const tl = (n) => '₺' + Math.round(n).toLocaleString('tr-TR');
const sayi = (n) => Math.round(n).toLocaleString('tr-TR');
const kisa = (n) => (n >= 1000000 ? (n / 1000000).toFixed(2).replace('.', ',') + 'M' : n >= 1000 ? Math.round(n / 1000) + 'K' : String(Math.round(n)));
const yuzde = (p, t) => (t ? (p / t * 100) : 0);
const delta = (yeni, eski) => (eski ? ((yeni - eski) / eski * 100) : null);

const satirlar = (f) => PLAN.filter(f);
const topla = (rows, alan) => rows.reduce((a, r) => a + (r[alan] || 0), 0);
const tik = (r) => (r.cpc ? r.butce / r.cpc : 0);
const gosterim = (r) => (r.cpm ? r.butce / r.cpm * 1000 : 0);
const izlenme = (r) => (r.cpv ? r.butce / r.cpv : 0);
const etkilesim = (r) => (r.amac === 'Etkileşim' ? gosterim(r) * 0.03 : 0);
/* CPC'yi kuruşuyla yaz: bu planın bütün iddiası birim maliyetlerin Ağustos'un
   GERÇEKLEŞEN verisi olması. ₺3,95'i "₺4" diye yuvarlamak o iddiayı çürütür. */
const kurus = (n) => '₺' + n.toFixed(2).replace('.', ',');
const ciktiMetni = (r) => {
  const p = [`${sayi(gosterim(r))} gösterim`];
  if (r.cpc) p.push(`${sayi(tik(r))} tıklama · ${kurus(r.cpc)} CPC`);
  if (r.cpv) p.push(`${sayi(izlenme(r))} izlenme · ₺${r.cpv.toFixed(2).replace('.', ',')} CPV`);
  if (r.amac === 'Etkileşim') p.push(`~${sayi(etkilesim(r))} etkileşim`);
  return p.join(' · ');
};

export const TOPLAM_BUTCE = topla(PLAN, 'butce');

/* ── Gerçekleşen bölümünün girdileri ─────────────────────────────────────────
   Plan tarafı elle yazılmıyor, PLAN dizisinden türetiliyor — bütçe değişince
   plan ↔ gerçekleşen kıyası da kendiliğinden düzeliyor.

   🔑🔑 Silo desenleri hesaptaki GERÇEK kampanya adlarına göre yazıldı
   (Glowy_Search_NeeDoh, Glowy_Store_Sales_Catalog_Playmobil, Glowy_YT_Needoh…).
   Hiçbir desene uymayan kampanya `varsayilan` siloya, yani Store geneline
   düşer; plandaki ₺400.000 zaten o kalemin karşılığı. Yeni bir marka silosu
   açılırsa desenini buraya da ekle, yoksa harcaması Store geneline yazılır. */
export const BRAND_ID = 'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9';

export const MECRA_PLANI = {
  GOOGLE_ADS: topla(PLAN.filter((r) => r.mecra === 'google'), 'butce'),
  META_ADS: topla(PLAN.filter((r) => r.mecra === 'meta'), 'butce'),
  TIKTOK_ADS: topla(PLAN.filter((r) => r.mecra === 'tiktok'), 'butce'),
};

const SILO_DESENI = {
  needoh: /needoh|nee[ _-]?doh/i,
  playmobil: /playmobil/i,
  charmit: /charm[ _-]?it/i,
  xmud: /x[ _-]?mud/i,
  antonio: /antonio[ _-]?juan/i,
  zoo: /zoo[ _-]?family/i,
};

export const SILO_PLANI = MARKALAR.map((m) => ({
  etiket: m.ad,
  butce: topla(PLAN.filter((r) => r.marka === m.key), 'butce'),
  desen: SILO_DESENI[m.key] || null,
  varsayilan: m.key === 'store',
}));

/* ═══════════════════════════ ALT BİLEŞENLER ═══════════════════════════ */

/* Bir markanın tam medya planı tablosu (mecra bazlı gruplu) */
function MarkaPlanTablosu({ marka }) {
  const rows = satirlar((r) => r.marka === marka.key);
  const butce = topla(rows, 'butce');
  const mecralar = ['google', 'meta', 'tiktok'].filter((m) => rows.some((r) => r.mecra === m));

  return (
    <div className="rounded-xl border overflow-hidden mb-6">
      <div className="px-4 py-3 flex items-center justify-between gap-3 border-b" style={{ backgroundColor: marka.renk + '12' }}>
        <div className="flex items-center gap-3 min-w-0">
          <span className="inline-block w-1.5 h-8 rounded-full flex-shrink-0" style={{ backgroundColor: marka.renk }} />
          <img src={marka.logo} alt={marka.ad} className="h-7 w-auto max-w-[110px] object-contain flex-shrink-0" />
          <div className="min-w-0">
            <p className="font-semibold text-gray-800 text-sm truncate">{marka.ad}</p>
            <p className="text-[11px] text-gray-500">
              {marka.urun > 0 ? `${sayi(marka.urun)} ürün feed'de` : 'feed’de ürün YOK'}
              {marka.sepet ? ` · ort. ${tl(marka.sepet)}` : ''}
              {` · marka araması ${sayi(marka.arama)}/ay`}
            </p>
          </div>
        </div>
        <span className="px-3 py-1.5 rounded-full text-white text-sm font-semibold flex-shrink-0" style={{ backgroundColor: marka.renk }}>
          {tl(butce)}
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Tahmini Çıktı</th>
              <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700 align-top">
            {mecralar.map((m) => {
              const mr = rows.filter((r) => r.mecra === m);
              const mb = topla(mr, 'butce');
              return (
                <React.Fragment key={m}>
                  {mr.map((r, i) => (
                    <tr key={r.kampanya} className="hover:bg-gray-50">
                      {i === 0 && (
                        <td className="px-4 py-3 font-medium align-top" rowSpan={mr.length}>
                          <div className="flex items-center gap-2">
                            <img src={MECRA[m].logo} alt={MECRA[m].ad} className="w-5 h-5 object-contain" />
                            <span className="whitespace-nowrap">{MECRA[m].ad}</span>
                          </div>
                        </td>
                      )}
                      <td className="px-4 py-3">
                        {r.kampanya}
                        {r.sart && (
                          <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded border border-amber-300 bg-amber-50 text-amber-800 text-[10px] font-medium whitespace-nowrap">
                            feed şartlı
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3">{r.kitle}</td>
                      <td className="px-4 py-3"><Amac tip={r.amac} /></td>
                      <td className="px-4 py-3">
                        {ciktiMetni(r)}
                        {r.kaynak === 'benchmark' && <span className="block text-[10px] text-gray-400 mt-0.5">birim maliyet: pazar benchmark&#8217;ı</span>}
                      </td>
                      <td className="px-4 py-3 text-right font-medium whitespace-nowrap">{tl(r.butce)}</td>
                    </tr>
                  ))}
                  <tr className={`font-semibold ${MECRA[m].satir}`}>
                    <td className="px-4 py-2.5" colSpan={4}>{MECRA[m].ad} Toplam</td>
                    <td className="px-4 py-2.5">
                      {sayi(topla(mr.map((r) => ({ v: gosterim(r) })), 'v'))} gösterim
                      {topla(mr.map((r) => ({ v: tik(r) })), 'v') > 0 && ` · ${sayi(topla(mr.map((r) => ({ v: tik(r) })), 'v'))} tıklama`}
                      {topla(mr.map((r) => ({ v: izlenme(r) })), 'v') > 0 && ` · ${kisa(topla(mr.map((r) => ({ v: izlenme(r) })), 'v'))} izlenme`}
                    </td>
                    <td className="px-4 py-2.5 text-right whitespace-nowrap">{tl(mb)}</td>
                  </tr>
                </React.Fragment>
              );
            })}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="px-4 py-3" colSpan={4}>{marka.ad.toUpperCase()} TOPLAM</td>
              <td className="px-4 py-3">
                {sayi(topla(rows.map((r) => ({ v: gosterim(r) })), 'v'))} gösterim ·{' '}
                {sayi(topla(rows.map((r) => ({ v: tik(r) })), 'v'))} tıklama
                {topla(rows.map((r) => ({ v: izlenme(r) })), 'v') > 0 && ` · ${kisa(topla(rows.map((r) => ({ v: izlenme(r) })), 'v'))} izlenme`}
              </td>
              <td className="px-4 py-3 text-right whitespace-nowrap">{tl(butce)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* NeeDoh talep grafiği — tek seri, tek renk, seçmeli doğrudan etiket.
   Ölçüleri SVG üzerinde AÇIKÇA yazılı (viewBox + width/height); ölçüsüz SVG
   html2canvas/PDF çıktısında eziliyor. */
function NeedohGrafik() {
  const W = 980, H = 260, PL = 52, PR = 16, PT = 28, PB = 42;
  const iw = W - PL - PR, ih = H - PT - PB;
  const maks = 50000;
  const bw = iw / NEEDOH_SERI.length;
  const gap = 2;                                   // komşu sütunlar arasında 2px zemin boşluğu
  const y = (v) => PT + ih - (v / maks) * ih;
  const isaret = [0, 12, 18, 23];                  // Ağu24 · Ağu25 · Şub26 · Tem26 — her sütuna etiket YOK
  const gridler = [0, 12500, 25000, 37500, 50000];

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img"
         aria-label="NeeDoh markasının Türkiye'deki aylık Google arama hacmi, Ağustos 2024 - Temmuz 2026"
         style={{ display: 'block', maxWidth: '100%' }}>
      {gridler.map((g) => (
        <g key={g}>
          <line x1={PL} x2={W - PR} y1={y(g)} y2={y(g)} stroke="#e5e7eb" strokeWidth="1" />
          <text x={PL - 8} y={y(g) + 4} textAnchor="end" fontSize="10" fill="#9ca3af">{g === 0 ? '0' : kisa(g)}</text>
        </g>
      ))}
      {NEEDOH_SERI.map((d, i) => {
        const h = Math.max(2, (d.v / maks) * ih);
        const x = PL + i * bw + gap / 2;
        const w = bw - gap;
        return (
          <g key={`${d.y}-${d.a}`}>
            {/* 4px yuvarlatılmış uç, taban çizgisine sabit */}
            <path
              d={`M ${x} ${PT + ih} L ${x} ${y(d.v) + Math.min(4, h)} Q ${x} ${y(d.v)} ${x + Math.min(4, w / 2)} ${y(d.v)} L ${x + w - Math.min(4, w / 2)} ${y(d.v)} Q ${x + w} ${y(d.v)} ${x + w} ${y(d.v) + Math.min(4, h)} L ${x + w} ${PT + ih} Z`}
              fill="#2a78d6"
            />
            {isaret.includes(i) && (
              <text x={x + w / 2} y={y(d.v) - 7} textAnchor="middle" fontSize="11" fontWeight="600" fill="#0b0b0b">
                {sayi(d.v)}
              </text>
            )}
            {(d.a === 1 || d.a === 7 || i === 0) && (
              <text x={x + w / 2} y={PT + ih + 15} textAnchor="middle" fontSize="9.5" fill="#6b7280">
                {AY_KISA[d.a]}
              </text>
            )}
            {(d.a === 1 || i === 0) && (
              <text x={x + w / 2} y={PT + ih + 28} textAnchor="middle" fontSize="9.5" fontWeight="600" fill="#52514e">
                {d.y}
              </text>
            )}
          </g>
        );
      })}
      <line x1={PL} x2={W - PR} y1={PT + ih} y2={PT + ih} stroke="#d1d5db" strokeWidth="1" />
    </svg>
  );
}

/* Ağustos→Eylül mevsimsellik tablosu */
function MevsimTablosu({ baslik, satirlarVeri, not }) {
  return (
    <div className="rounded-xl border overflow-hidden">
      <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">{baslik}</div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-[11px]">
          <thead className="bg-gray-50 text-gray-500">
            <tr>
              <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Kelime</th>
              <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Ağu 25</th>
              <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Eyl 25</th>
              <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Δ 25</th>
              <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Δ 24</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
            {satirlarVeri.map((s) => {
              const d25 = delta(s.e25, s.a25), d24 = delta(s.e24, s.a24);
              const renk = (d) => (d > 5 ? 'text-emerald-600' : d < -5 ? 'text-red-600' : 'text-gray-500');
              return (
                <tr key={s.kw}>
                  <td className="px-3 py-2 font-medium">{s.kw}</td>
                  <td className="px-3 py-2 text-right">{sayi(s.a25)}</td>
                  <td className="px-3 py-2 text-right">{sayi(s.e25)}</td>
                  <td className={`px-3 py-2 text-right font-semibold ${renk(d25)}`}>{d25 > 0 ? '+' : ''}{Math.round(d25)}%</td>
                  <td className={`px-3 py-2 text-right font-semibold ${renk(d24)}`}>{d24 > 0 ? '+' : ''}{Math.round(d24)}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {not && <div className="px-4 py-2 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">{not}</div>}
    </div>
  );
}

/* ═══════════════ CİRO RÖNTGENİ BİLEŞENLERİ ═══════════════
   Tamamı TEK hue (#2a78d6): buradaki renk kimlik değil büyüklük taşıyor.
   Ölçüler SVG'ye açıkça yazılı — ölçüsüz SVG PDF/html2canvas çıktısında eziliyor. */

const CIRO_HUE = '#2a78d6';

/* Yüzdelerin Türkçe iyelik eki — "%46'si" değil "%46'sı", "%69'i" değil "%69'u".
   Ek, sayının OKUNUŞUNUN son hecesine bağlı; birler basamağı 0 ise onluğun
   kendisine bakılır (30 "otuz" → u, 40 "kırk" → ı). */
const TR_EK = { 0: 'ı', 1: 'i', 2: 'si', 3: 'ü', 4: 'dü', 5: 'i', 6: 'sı', 7: 'si', 8: 'i', 9: 'u', 10: 'u', 20: 'si', 30: 'u', 40: 'ı', 50: 'si', 60: 'ı', 70: 'i', 80: 'i', 90: 'ı', 100: 'ü' };
const ek = (n) => {
  const v = Math.round(Math.abs(n));
  if (v >= 100) return TR_EK[100];
  const b = v % 10;
  return b ? TR_EK[b] : (TR_EK[v] || 'ı');
};


/* Satır içi 6 aylık seyir — tek seri, tek renk, doğrudan etiket YOK.
   🔑 Ölçek SATIR İÇİNDE: her çubuk grubu kendi tepesine göre çizilir, markalar
   arası DEĞİL. Ortak ölçek denendi ve kullanılamaz çıktı — "Diğer" 5,9 milyonla
   ölçeği tek başına belirleyince dokuz markanın hepsi düz çizgiye iniyordu, yani
   çubuklar hiçbir şey anlatmıyordu. Bu grafiğin işi büyüklük değil BİÇİM:
   markanın altı ayı nasıl dağıldığı. Büyüklüğü zaten yanındaki çubuk ve tutar
   söylüyor. Sayı okumak için çubuğun üzerine gelinir. */
function Seyir({ ay, aylar = CIRO_AYLAR }) {
  const W = 116, H = 30, gap = 2;
  const bw = W / ay.length;
  const tepe = Math.max(1, ...ay);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width={W} height={H} role="img"
         aria-label={aylar.map((a, i) => `${a} ${Math.round(ay[i]).toLocaleString('tr-TR')} lira`).join(', ')}
         style={{ display: 'block' }}>
      {ay.map((v, i) => {
        const h = tepe > 0 ? Math.max(v > 0 ? 1.5 : 0, (v / tepe) * (H - 2)) : 0;
        const x = i * bw + gap / 2, w = bw - gap, y = H - h;
        const r = Math.min(2, w / 2, h);
        return (
          <path key={i} fill={CIRO_HUE} opacity={v > 0 ? 1 : 0}
                d={`M ${x} ${H} L ${x} ${y + r} Q ${x} ${y} ${x + r} ${y} L ${x + w - r} ${y} Q ${x + w} ${y} ${x + w} ${y + r} L ${x + w} ${H} Z`}>
            <title>{`${aylar[i]}: ${tl(v)}`}</title>
          </path>
        );
      })}
      {ay.every((v) => v === 0) && (
        <text x={W / 2} y={H / 2 + 4} textAnchor="middle" fontSize="10" fill="#9ca3af">satış yok</text>
      )}
    </svg>
  );
}

/* Yatay büyüklük çubuğu — tek hue, 2px yuvarlatılmış uç, taban sola sabit */
function CiroBar({ v, maks }) {
  const p = maks > 0 ? Math.max(v > 0 ? 0.8 : 0, (v / maks) * 100) : 0;
  return (
    <span className="inline-block w-full h-2 rounded-sm bg-gray-100 overflow-hidden align-middle">
      <span className="block h-full rounded-sm" style={{ width: `${p}%`, backgroundColor: CIRO_HUE }} />
    </span>
  );
}

/* Ciro tablosu satırı */
function CiroSatir({ r, maks, toplam, butce, vurgu }) {
  const sepet = r.adet ? r.ciro / r.adet : 0;
  const aylikOrt = r.ciro / 6;
  const kat = butce && aylikOrt > 0 ? butce / aylikOrt : null;
  return (
    <tr className={vurgu === 'yok' ? 'bg-rose-50/60' : 'hover:bg-gray-50'}>
      <td className="px-3 py-2.5 font-medium text-gray-800 whitespace-nowrap">{r.ad}</td>
      <td className="px-3 py-2.5 w-[150px]">
        <CiroBar v={r.ciro} maks={maks} />
      </td>
      <td className="px-3 py-2.5 text-right font-semibold text-gray-900 whitespace-nowrap tabular-nums">{tl(r.ciro)}</td>
      <td className="px-3 py-2.5 text-right text-gray-600 whitespace-nowrap tabular-nums">%{yuzde(r.ciro, toplam).toFixed(1).replace('.', ',')}</td>
      <td className="px-3 py-2.5 text-right text-gray-600 tabular-nums">{sayi(r.adet)}</td>
      <td className="px-3 py-2.5 text-right text-gray-600 whitespace-nowrap tabular-nums">{r.adet ? tl(sepet) : '—'}</td>
      <td className="px-3 py-2.5"><Seyir ay={r.ay} /></td>
      <td className="px-3 py-2.5 text-right whitespace-nowrap tabular-nums">
        {butce ? <span className="font-semibold text-gray-900">{tl(butce)}</span> : <span className="text-gray-400">—</span>}
      </td>
      <td className="px-3 py-2.5 text-right whitespace-nowrap tabular-nums">
        {!butce ? <span className="text-gray-400">—</span>
          : kat === null ? <span className="font-semibold text-rose-700">ölçülemez</span>
          : <span className={kat >= 3 ? 'font-semibold text-rose-700' : kat >= 1 ? 'font-semibold text-amber-700' : 'text-gray-600'}>
              {kat.toFixed(1).replace('.', ',')}×
            </span>}
      </td>
    </tr>
  );
}

/* B2S iki yıllık mevsim çubukları — iki AYRI grafik (small multiples),
   tek hue. İki yılı tek eksende üst üste bindirmek yıllar arası %122'lik
   büyüme yüzünden 2025'i görünmez yapıyordu. */
function B2SMevsim({ seri, baslik, tepe, isaretle }) {
  const W = 300, H = 130, PL = 8, PR = 8, PT = 22, PB = 22;
  const iw = W - PL - PR, ih = H - PT - PB;
  const bw = iw / seri.length, gap = 4;
  return (
    <div>
      <p className="text-[11px] font-semibold text-gray-700 mb-1">{baslik}</p>
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img"
           aria-label={`${baslik}: ` + seri.map((d) => `${d.ay} ${Math.round(d.v).toLocaleString('tr-TR')} lira`).join(', ')}
           style={{ display: 'block', maxWidth: '100%' }}>
        {seri.map((d, i) => {
          const h = Math.max(2, (d.v / tepe) * ih);
          const x = PL + i * bw + gap / 2, w = bw - gap, y = PT + ih - h;
          const r = Math.min(4, w / 2, h);
          const on = isaretle.includes(d.ay);
          return (
            <g key={d.ay}>
              <path fill={CIRO_HUE} opacity={on ? 1 : 0.45}
                    d={`M ${x} ${PT + ih} L ${x} ${y + r} Q ${x} ${y} ${x + r} ${y} L ${x + w - r} ${y} Q ${x + w} ${y} ${x + w} ${y + r} L ${x + w} ${PT + ih} Z`}>
                <title>{`${d.ay}: ${tl(d.v)}`}</title>
              </path>
              {on && <text x={x + w / 2} y={y - 6} textAnchor="middle" fontSize="10.5" fontWeight="600" fill="#0b0b0b">{kisa(d.v)}</text>}
              <text x={x + w / 2} y={PT + ih + 14} textAnchor="middle" fontSize="10" fill="#6b7280">{d.ay}</text>
            </g>
          );
        })}
        <line x1={PL} x2={W - PR} y1={PT + ih} y2={PT + ih} stroke="#d1d5db" strokeWidth="1" />
      </svg>
    </div>
  );
}

/* ── Aylık ciro tablosu — rakamla, ay ay ─────────────────────────────────────
   Üstteki özet tabloların "Mar → Ağu" çubukları biçimi gösteriyor ama sayıyı
   ancak üzerine gelince veriyor. Bu tablo aynı veriyi okunabilir rakam olarak
   veriyor; ikisi AYNI `ay` dizisinden türüyor, ayrı bir kaynak yok.

   İki yerde kullanılıyor (marka özeti + "Diğer"in ilk 20'si), o yüzden satırları
   dışarıdan alıyor. `tip: 'ara'` ara toplam satırı demek: zemini boyanmaz,
   çünkü ara toplamın "zirve ayı" markanınkiyle aynı anlamı taşımıyor.

   Hücre zemini satır içinde koyulaşıyor (tek hue, sequential): markanın hangi
   ayda zirve yaptığı satırı okumadan görünsün. Zemin bilgiyi TEK BAŞINA
   taşımıyor — rakam zaten hücrenin içinde, zirve ayı ayrıca son sütunda yazılı.
   Alfa 0,30'da tutuldu, üstündeki metin koyu kalsın diye. */
function AylikTablo({ baslik, sagNot, satirlar, toplamAd, altNot }) {
  const aylikToplam = CIRO_AYLAR.map((_, i) =>
    satirlar.filter((r) => r.tip !== 'ara').reduce((a, r) => a + r.ay[i], 0));
  const genelToplam = aylikToplam.reduce((a, v) => a + v, 0);

  const zirve = (ay) => {
    const m = Math.max(...ay);
    return m > 0 ? CIRO_AYLAR[ay.indexOf(m)] : '—';
  };
  const zemin = (v, tepe) => (v
    ? { backgroundColor: CIRO_HUE + Math.round((v / tepe) * 0.30 * 255).toString(16).padStart(2, '0') }
    : undefined);

  return (
    <div className="rounded-xl border overflow-hidden mb-5">
      <div className="bg-slate-100 px-4 py-3 flex items-center justify-between gap-3">
        <span className="font-semibold text-gray-800 text-sm">{baslik}</span>
        <span className="text-[11px] text-gray-500">{sagNot}</span>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider sticky left-0 bg-gray-50 z-10">Marka</th>
              {CIRO_AYLAR.map((a) => (
                <th key={a} className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">{a}</th>
              ))}
              <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider border-l border-gray-200">6 Ay</th>
              <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Zirve</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100 text-[12px]">
            {satirlar.map((r) => {
              const rowToplam = r.ay.reduce((a, v) => a + v, 0);
              const tepe = Math.max(1, ...r.ay);
              const ara = r.tip === 'ara';
              return (
                <tr key={r.key} className={ara ? 'bg-gray-50 font-semibold text-gray-800' : 'hover:bg-gray-50/70'}>
                  <td className={`px-3 py-2.5 whitespace-nowrap sticky left-0 z-10 ${ara ? 'bg-gray-50 font-semibold' : 'bg-white font-medium text-gray-800'}`}>
                    {r.ad}
                  </td>
                  {r.ay.map((v, i) => (
                    <td key={i}
                        className={`px-3 py-2.5 text-right tabular-nums whitespace-nowrap ${v ? 'text-gray-800' : 'text-gray-300'}`}
                        style={ara ? undefined : zemin(v, tepe)}>
                      {v ? sayi(v) : '—'}
                    </td>
                  ))}
                  <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap font-semibold text-gray-900 border-l border-gray-200">
                    {rowToplam ? sayi(rowToplam) : '—'}
                  </td>
                  <td className="px-3 py-2.5 text-right text-gray-500 whitespace-nowrap">{zirve(r.ay)}</td>
                </tr>
              );
            })}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="px-3 py-3 whitespace-nowrap sticky left-0 z-10 bg-gray-800">{toplamAd}</td>
              {aylikToplam.map((v, i) => (
                <td key={i} className="px-3 py-3 text-right tabular-nums whitespace-nowrap">{sayi(v)}</td>
              ))}
              <td className="px-3 py-3 text-right tabular-nums whitespace-nowrap border-l border-gray-600">{sayi(genelToplam)}</td>
              <td className="px-3 py-3 text-right">{zirve(aylikToplam)}</td>
            </tr>
            <tr className="bg-gray-100 text-gray-600 text-[11px]">
              <td className="px-3 py-2 whitespace-nowrap sticky left-0 z-10 bg-gray-100">Bir önceki aya göre</td>
              {aylikToplam.map((v, i) => {
                const d = i === 0 ? null : delta(v, aylikToplam[i - 1]);
                return (
                  <td key={i} className={`px-3 py-2 text-right tabular-nums whitespace-nowrap ${d === null ? 'text-gray-400' : d > 0 ? 'text-emerald-700' : 'text-rose-700'}`}>
                    {d === null ? '—' : `${d > 0 ? '+' : ''}%${Math.round(d)}`}
                  </td>
                );
              })}
              <td className="px-3 py-2 border-l border-gray-200" colSpan={2} />
            </tr>
          </tbody>
        </table>
      </div>
      <div className="px-4 py-2.5 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">
        Hücre zemini <strong>satır içinde</strong> koyulaşır — markanın kendi zirvesi göze çarpsın diye; satırlar arası karşılaştırma için değil.
        Boş hücre o ay <strong>hiç satış olmadığı</strong> anlamına gelir, veri eksikliği değil. {altNot}
      </div>
    </div>
  );
}

/* ── Ciro röntgeni bölümünün tamamı ─────────────────────────────────────── */
function CiroRontgeni({ markaButce }) {
  const markaToplam = CIRO.reduce((a, r) => a + r.ciro, 0);
  const TOPLAM = markaToplam + CIRO_B2S.ciro + CIRO_DIGER.ciro;
  const maks = Math.max(...CIRO.map((r) => r.ciro), CIRO_B2S.ciro, CIRO_DIGER.ciro);
  const digerMaks = Math.max(...DIGER_ILK20.map((r) => r.ciro));
  const butceli = CIRO.filter((r) => r.plan);
  const butceliCiro = butceli.reduce((a, r) => a + r.ciro, 0);
  const butceliButce = butceli.reduce((a, r) => a + markaButce(r.plan), 0);
  const b2sTepe = Math.max(...B2S_MEVSIM.y2025.map((d) => d.v), ...B2S_MEVSIM.y2026.map((d) => d.v));
  /* Metindeki rakamlar da veriden okunuyor — dönem yenilendiğinde cümleyle
     tablo ayrışmasın. Elle yazılmış tek rakam kalmasın istiyoruz. */
  const bul = (k) => CIRO.find((r) => r.key === k);
  const enCok = CIRO.reduce((a, r) => (r.ciro > a.ciro ? r : a), CIRO[0]);
  const kucukIkili = bul('charmit').ciro + bul('xmud').ciro;
  const kucukIkiliButce = markaButce('charmit') + markaButce('xmud');
  const eylulOran = 201881 / 278607;                     // 2025 Eylül / Ağustos
  const b2sEylulTahmin = 488644 * eylulOran;             // 2026 Ağustos × geçen yılın oranı
  const grup = [
    { ad: `Eylül'de ayrı bütçesi olan 6 marka`, v: butceliCiro, not: `${tl(butceliButce)} bütçe ayrıldı` },
    { ad: 'Bütçesi olmayan 3 marka (Modu, Smiggle, Meli)', v: markaToplam - butceliCiro, not: 'Store genel bütçesinden besleniyor' },
    { ad: 'Okul Setleri / B2S', v: CIRO_B2S.ciro, not: 'ayrı bütçe yok' },
    { ad: `Diğer — ${sayi(CIRO_DIGER_MARKA_SAYISI)} marka`, v: CIRO_DIGER.ciro, not: 'ayrı bütçe yok' },
  ];

  return (
    <div className="mb-8">
      <h3 className="text-base font-bold text-gray-800 mb-1">Ciro Röntgeni — Son 6 Ay</h3>
      <p className="text-xs text-gray-500 mb-4">
        1 Mart – 31 Ağustos 2026 · GA4 ürün performansı · toplam <strong className="text-gray-700">{tl(TOPLAM)}</strong> ·{' '}
        katalogda satış yapan {sayi(CIRO_TOPLAM_MARKA)} markanın tamamı dahil
      </p>

      {/* Tanım kutusu — rakamlar okunmadan önce iki kural */}
      <div className="mb-5 p-3.5 rounded-xl bg-slate-50 border border-slate-200 text-[11px] text-gray-700 leading-relaxed">
        <p className="font-semibold text-gray-800 mb-1 text-[11.5px]">Bu tablo nasıl kuruldu</p>
        <p>
          Kaynak <strong>GA4 ürün performansı</strong> (property 364875770), boyut <code className="px-1 rounded bg-white border text-[10px]">itemBrand</code> ×{' '}
          <code className="px-1 rounded bg-white border text-[10px]">itemCategory</code>, metrik <code className="px-1 rounded bg-white border text-[10px]">itemRevenue</code>.
          Property&#8217;deki <code className="px-1 rounded bg-white border text-[10px]">purchaseRevenue</code> ile aynı — yani bu, sitenin
          bir dilimi değil <strong>toplam cirosu</strong>. Tutarlar tam liraya yuvarlıdır; aylık tablo da satır toplamları da aynı yuvarlanmış
          değerlerden türediği için iki tablo birbirini kuruşuna kadar tutar.
        </p>
        <p className="mt-1.5">
          <strong>Okul Setleri / B2S</strong> = GA4&#8217;te <em>Kırtasiye Ürünleri</em> ana kategorisinin tamamı (çanta ve kalem kutusu, suluk-termos, beslenme
          çantası, jel kalem, sticker, aktivite seti…). Kategori ağacında &#8220;okul seti&#8221; diye tek bir dal yok; en yakın karşılık bu.
        </p>
        <p className="mt-1.5">
          <strong>Çakışma marka lehine çözüldü:</strong> Smiggle cirosunun %99&#8217;u kırtasiye kategorisinde. Kendi satırında sayıldı, B2S satırından düşüldü.
          Bu yüzden <strong>11 satırın toplamı tam olarak {tl(TOPLAM)}</strong> — hiçbir kuruş iki kez sayılmıyor, &#8220;Diğer&#8221; gerçekten geri kalan.
        </p>
      </div>

      {/* Üç rakam — grafik değil, çünkü soru tek: kim ne kadar? */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
        {grup.map((g) => (
          <div key={g.ad} className="rounded-xl border border-gray-200 bg-white p-3.5">
            <p className="text-[11px] text-gray-500 leading-snug min-h-[2.2rem]">{g.ad}</p>
            <p className="text-xl font-bold text-gray-900 mt-1 tabular-nums">{tl(g.v)}</p>
            <p className="text-[11px] text-gray-500 mt-0.5">
              <span className="font-semibold text-gray-700">%{yuzde(g.v, TOPLAM).toFixed(1).replace('.', ',')}</span> · {g.not}
            </p>
          </div>
        ))}
      </div>

      {/* Ana tablo */}
      <div className="rounded-xl border overflow-hidden mb-5">
        <div className="bg-slate-100 px-4 py-3 flex items-center justify-between gap-3">
          <span className="font-semibold text-gray-800 text-sm">Marka bazında ciro — 6 ay</span>
          <span className="text-[11px] text-gray-500">ciroya göre sıralı</span>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Marka</th>
                <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Büyüklük</th>
                <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">6 Aylık Ciro</th>
                <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Pay</th>
                <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Adet</th>
                <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Ort. Fiyat</th>
                <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Mar → Ağu</th>
                <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Eylül Bütçesi</th>
                <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Bütçe / Aylık Ciro</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100 text-[12px]">
              {CIRO.map((r) => (
                <CiroSatir key={r.key} r={r} maks={maks} toplam={TOPLAM}
                           butce={r.plan ? markaButce(r.plan) : 0}
                           vurgu={r.plan && r.ciro === 0 ? 'yok' : null} />
              ))}
              <tr className="bg-gray-50 font-semibold text-gray-800 text-[12px]">
                <td className="px-3 py-2.5" colSpan={2}>Dokuz markanın toplamı</td>
                <td className="px-3 py-2.5 text-right tabular-nums">{tl(markaToplam)}</td>
                <td className="px-3 py-2.5 text-right tabular-nums">%{yuzde(markaToplam, TOPLAM).toFixed(1).replace('.', ',')}</td>
                <td className="px-3 py-2.5 text-right tabular-nums">{sayi(CIRO.reduce((a, r) => a + r.adet, 0))}</td>
                <td className="px-3 py-2.5" colSpan={2} />
                <td className="px-3 py-2.5 text-right tabular-nums">{tl(butceliButce)}</td>
                <td className="px-3 py-2.5" />
              </tr>
              <CiroSatir r={CIRO_B2S} maks={maks} toplam={TOPLAM} butce={0} />
              <CiroSatir r={{ ...CIRO_DIGER, ad: `Diğer — ${sayi(CIRO_DIGER_MARKA_SAYISI)} marka` }} maks={maks} toplam={TOPLAM} butce={0} />
              <tr className="bg-gray-800 text-white font-bold text-[12px]">
                <td className="px-3 py-3" colSpan={2}>TOPLAM CİRO (6 ay)</td>
                <td className="px-3 py-3 text-right tabular-nums">{tl(TOPLAM)}</td>
                <td className="px-3 py-3 text-right tabular-nums">%100</td>
                <td className="px-3 py-3 text-right tabular-nums">{sayi(CIRO.reduce((a, r) => a + r.adet, 0) + CIRO_B2S.adet + CIRO_DIGER.adet)}</td>
                <td className="px-3 py-3" colSpan={4} />
              </tr>
            </tbody>
          </table>
        </div>
        <div className="px-4 py-2.5 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">
          <strong>Bütçe / Aylık Ciro</strong> = Eylül&#8217;de o markaya ayrılan bütçe ÷ markanın son 6 aydaki aylık ortalama cirosu. 1,0× &#8220;bir aylık cirosu kadar
          bütçe&#8221; demek. <strong>Mar → Ağu</strong> çubukları markanın altı ayının nasıl dağıldığını gösterir; <strong>ölçek her satırın kendi içindedir</strong>,
          satırlar arası değil — yani iki farklı satırdaki aynı yükseklikteki çubuk aynı ciro anlamına gelmez. Büyüklük karşılaştırması için soldaki
          <strong> Büyüklük</strong> çubuğu ve tutar sütunu kullanılır; onların ölçeği tablonun tamamında ortaktır. Bir ayın cirosunu okumak için çubuğun üzerine gelin.
        </div>
      </div>

      {/* Aylık kırılım — rakamla */}
      <AylikTablo
        baslik="Aylık kırılım — Mart–Ağustos 2026"
        sagNot="tutarlar ₺ · üstteki tabloyla aynı sıra"
        toplamAd="AYLIK TOPLAM"
        satirlar={[
          ...CIRO,
          { key: '__marka__', ad: 'Dokuz markanın toplamı', tip: 'ara',
            ay: CIRO_AYLAR.map((_, i) => CIRO.reduce((a, r) => a + r.ay[i], 0)) },
          CIRO_B2S,
          { ...CIRO_DIGER, ad: `Diğer — ${sayi(CIRO_DIGER_MARKA_SAYISI)} marka` },
        ]}
        altNot={<>Satırların ve ayların toplamı iki yönde de {tl(TOPLAM)}&#8217;ye kapanır.</>}
      />

      {/* Bütçe ↔ ciro çelişkisi */}
      <div className="mb-5 p-4 rounded-xl bg-rose-50 border border-rose-200">
        <p className="text-xs font-semibold text-rose-900 mb-1.5">Bütçe, ciroyu takip etmiyor — üç sayı</p>
        <ul className="text-[11px] text-rose-800 leading-relaxed space-y-1 list-disc pl-4">
          <li>
            <strong>NeeDoh son 6 ayda {tl(0)} sattı.</strong> GA4&#8217;te bu marka adına tek bir satır yok — feed&#8217;de ürün olmadığı için sitede de satılamıyor.
            Plan bu markaya <strong>{tl(markaButce('needoh'))}</strong> ayırıyor, yani toplam bütçenin %{Math.round(yuzde(markaButce('needoh'), TOPLAM_BUTCE))}&#8217;{ek(yuzde(markaButce('needoh'), TOPLAM_BUTCE))}.
            Talep gerçek ({sayi(49500)} aylık arama) ama <strong>satılacak ürün yok</strong>.
          </li>
          <li>
            <strong>{enCok.ad} {tl(enCok.ciro)} ile en çok satan marka</strong> — dokuz markanın toplamının %{Math.round(yuzde(enCok.ciro, markaToplam))}&#8217;{ek(yuzde(enCok.ciro, markaToplam))} tek başına ondan —
            ve plandaki <strong>en küçük bütçeyi</strong> alıyor ({tl(markaButce(enCok.plan))}). Buna karşılık Charm It ({tl(bul('charmit').ciro)}) ve X Mud ({tl(bul('xmud').ciro)}) birlikte
            6 ayda {tl(kucukIkili)} satarken {tl(kucukIkiliButce)} bütçe alıyor — <strong>altı aylık cirolarının {Math.round(kucukIkiliButce / kucukIkili)} katı</strong>.
          </li>
          <li>
            <strong>Sitenin cirosunun %{yuzde(CIRO_DIGER.ciro, TOPLAM).toFixed(0)}&#8217;{ek(yuzde(CIRO_DIGER.ciro, TOPLAM))} planda adı geçmeyen markalardan geliyor.</strong> {DIGER_ILK20[0].ad} ({tl(DIGER_ILK20[0].ciro)}),{' '}
            {DIGER_ILK20[1].ad} ({tl(DIGER_ILK20[1].ciro)}) ve {DIGER_ILK20[2].ad} ({tl(DIGER_ILK20[2].ciro)}) — üçü de {enCok.ad} dışındaki her plan markasından büyük, üçünün de ayrı bütçesi yok.
          </li>
        </ul>
      </div>

      {/* Diğer'in içi */}
      <div className="rounded-xl border overflow-hidden mb-5">
        <div className="bg-slate-100 px-4 py-3">
          <span className="font-semibold text-gray-800 text-sm">&#8220;Diğer&#8221;in içinde ne var — ilk 20 marka</span>
          <span className="block text-[11px] text-gray-500 mt-0.5">
Satış yapan {sayi(CIRO_DIGER_MARKA_SAYISI)} markanın en büyük 20&#8217;si, {tl(DIGER_ILK20.reduce((a, r) => a + r.ciro, 0))} —
            &#8220;Diğer&#8221;in %{Math.round(yuzde(DIGER_ILK20.reduce((a, r) => a + r.ciro, 0), CIRO_DIGER.ciro))}&#8217;{ek(yuzde(DIGER_ILK20.reduce((a, r) => a + r.ciro, 0), CIRO_DIGER.ciro))}. Hiçbirinin Eylül planında ayrı bütçesi yok.
          </span>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">#</th>
                <th className="px-3 py-2 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Marka</th>
                <th className="px-3 py-2 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Büyüklük</th>
                <th className="px-3 py-2 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">6 Aylık Ciro</th>
                <th className="px-3 py-2 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Pay</th>
                <th className="px-3 py-2 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Adet</th>
                <th className="px-3 py-2 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Ort. Fiyat</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100 text-[12px]">
              {DIGER_ILK20.map((r, i) => (
                <tr key={r.ad} className="hover:bg-gray-50">
                  <td className="px-3 py-2 text-gray-400 tabular-nums">{i + 1}</td>
                  <td className="px-3 py-2 font-medium text-gray-800 whitespace-nowrap">{r.ad}</td>
                  <td className="px-3 py-2 w-[170px]"><CiroBar v={r.ciro} maks={digerMaks} /></td>
                  <td className="px-3 py-2 text-right font-semibold text-gray-900 whitespace-nowrap tabular-nums">{tl(r.ciro)}</td>
                  <td className="px-3 py-2 text-right text-gray-600 whitespace-nowrap tabular-nums">%{yuzde(r.ciro, TOPLAM).toFixed(1).replace('.', ',')}</td>
                  <td className="px-3 py-2 text-right text-gray-600 tabular-nums">{sayi(r.adet)}</td>
                  <td className="px-3 py-2 text-right text-gray-600 whitespace-nowrap tabular-nums">{tl(r.ciro / r.adet)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* "Diğer"in ilk 20'si — aylık */}
      <AylikTablo
        baslik="&#8220;Diğer&#8221;in ilk 20 markası — aylık kırılım"
        sagNot="tutarlar ₺ · üstteki tabloyla aynı sıra"
        toplamAd="İLK 20 TOPLAM"
        satirlar={DIGER_ILK20}
        altNot={<>
          Bu yirmi marka &#8220;Diğer&#8221;in {tl(CIRO_DIGER.ciro)}&#8217;lik cirosunun{' '}
          %{Math.round(yuzde(DIGER_ILK20.reduce((a, r) => a + r.ciro, 0), CIRO_DIGER.ciro))}&#8217;{ek(yuzde(DIGER_ILK20.reduce((a, r) => a + r.ciro, 0), CIRO_DIGER.ciro))}
          ni taşıyor; kalanı {sayi(CIRO_DIGER_MARKA_SAYISI - DIGER_ILK20.length)} markaya dağılmış durumda.
          Bu tablonun &#8220;Bir önceki aya göre&#8221; satırı yalnız bu yirmi markanın toplamını izler, &#8220;Diğer&#8221;in tamamını değil.
        </>}
      />

      {/* B2S mevsimselliği */}
      <div className="rounded-xl border overflow-hidden">
        <div className="bg-slate-100 px-4 py-3">
          <span className="font-semibold text-gray-800 text-sm">Okul dönemi Eylül&#8217;de bitmiyor — ama planda ayrı bütçesi yok</span>
        </div>
        <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <B2SMevsim seri={B2S_MEVSIM.y2025} baslik="2025 — Kırtasiye cirosu" tepe={b2sTepe} isaretle={['Ağu', 'Eyl']} />
            <B2SMevsim seri={B2S_MEVSIM.y2026} baslik="2026 — Kırtasiye cirosu" tepe={b2sTepe} isaretle={['Ağu']} />
          </div>
          <div className="text-[11.5px] text-gray-700 leading-relaxed space-y-2">
            <p>
              İki grafik <strong>aynı eksende</strong>: 2026 Ağustos&#8217;u {tl(488644)} ile geçen yılın Ağustos&#8217;unun ({tl(278607)})
              <strong> %{Math.round(delta(488644, 278607))} üzerinde</strong>. Kırtasiye, Ağustos&#8217;ta sitenin toplam cirosunun
              %{Math.round(yuzde(488644, 1410095))}&#8217;{ek(yuzde(488644, 1410095))}ni tek başına taşıdı.
            </p>
            <p>
              Geçen yıl <strong>Eylül, Ağustos&#8217;un %{Math.round(eylulOran * 100)}&#8217;{ek(eylulOran * 100)} kadar</strong> geldi ({tl(201881)}) — okul dönemi Eylül&#8217;de bitmiyor,
              yavaşlayarak sürüyor. Aynı oran bu yıla uygulanırsa Eylül&#8217;de kırtasiyeden <strong>~{tl(b2sEylulTahmin)}</strong> beklenir; bu, planın
              tamamının %{Math.round(yuzde(b2sEylulTahmin, TOPLAM_BUTCE))}&#8217;{ek(yuzde(b2sEylulTahmin, TOPLAM_BUTCE))} büyüklüğünde bir ciro.
            </p>
            <p className="p-2.5 rounded-lg bg-amber-50 border border-amber-200 text-amber-900">
              <strong>Karar gerektiren nokta:</strong> Eylül planında NeeDoh&#8217;a {tl(markaButce('needoh'))} ayrılırken okul/kırtasiye tarafına
              <strong> ayrı tek kuruş yok</strong> — Store&#8217;un genel {tl(markaButce('store'))}&#8217;i içinde eriyor. Son 6 ayın verisine göre kırtasiye{' '}
              {tl(CIRO_B2S.ciro)} getirmiş, NeeDoh {tl(0)}. Bütçenin bir bölümünün NeeDoh feed&#8217;i açılana kadar burada bekletilmesi
              tartışılmalı.
            </p>
          </div>
        </div>
        <div className="px-4 py-2.5 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">
          Bu iki grafikteki kırtasiye rakamları <strong>Smiggle dahil ham kategori cirosudur</strong> — yukarıdaki tabloda Smiggle kendi satırına
          çekildiği için B2S satırı {tl(CIRO_B2S.ciro)}, buradaki 6 ayın toplamı {tl(B2S_MEVSIM.y2026.reduce((a, d) => a + d.v, 0))}. Aradaki fark
          Smiggle&#8217;ın kırtasiyedeki payıdır; iki yılı karşılaştırabilmek için burada bilerek düşülmedi.
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════ ANA SAYFA ═══════════════════════════ */

export default function HupalupaStoreEylul2026MedyaPlani() {
  const mecraToplam = {
    google: topla(satirlar((r) => r.mecra === 'google'), 'butce'),
    meta: topla(satirlar((r) => r.mecra === 'meta'), 'butce'),
    tiktok: topla(satirlar((r) => r.mecra === 'tiktok'), 'butce'),
  };
  const amacToplam = {
    'Dönüşüm': topla(satirlar((r) => r.amac === 'Dönüşüm'), 'butce'),
    'Farkındalık': topla(satirlar((r) => r.amac === 'Farkındalık'), 'butce'),
    'Etkileşim': topla(satirlar((r) => r.amac === 'Etkileşim'), 'butce'),
  };
  const genelTik = topla(PLAN.map((r) => ({ v: tik(r) })), 'v');
  const genelGosterim = topla(PLAN.map((r) => ({ v: gosterim(r) })), 'v');
  const genelIzlenme = topla(PLAN.map((r) => ({ v: izlenme(r) })), 'v');
  const genelEtkilesim = topla(PLAN.map((r) => ({ v: etkilesim(r) })), 'v');
  const feedSartli = topla(satirlar((r) => r.sart), 'butce');

  const markaButce = (k) => topla(satirlar((r) => r.marka === k), 'butce');
  const markaMecra = (k, m) => topla(satirlar((r) => r.marka === k && r.mecra === m), 'butce');

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">

        {/* ── Başlık ── */}
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-2">
              <img src="https://hupalupa.store/Data/EditorFiles/Devux/logo-1.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Eylül 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">
                Store genel bütçesi + altı markanın ayrı yönetilen bütçesi · Google Ads • Meta Ads • TikTok Ads
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Eylül 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Toplam: {tl(TOPLAM_BUTCE)}
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* ── Marka bütçeli sürüme bağlantı ──
              3 Eyl'de marka kendi bütçe dağılımını gönderdi; o sürüm AYRI bir sayfa.
              Bu sayfa duruyor çünkü ikisinin kıyası sunumun kendisi. */}
          <div className="mb-6 p-3.5 rounded-xl bg-blue-50 border border-blue-200 flex flex-col sm:flex-row sm:items-center gap-2 sm:justify-between">
            <p className="text-[11.5px] text-blue-900 leading-relaxed">
              <strong>3 Eylül:</strong> marka tarafı kendi bütçe dağılımını gönderdi ({tl(1215000)}). Bu sayfa
              <strong> bizim önerimizdir</strong> ({tl(TOPLAM_BUTCE)}) ve olduğu gibi duruyor; marka bütçesiyle kurulmuş sürüm ayrı bir sayfada.
            </p>
            <a href="/budget/hupalupa-store-eylul-2026-marka-butcesi"
               className="inline-flex items-center justify-center px-3 py-1.5 rounded-lg bg-blue-600 text-white text-[11.5px] font-semibold whitespace-nowrap hover:bg-blue-700">
              Marka bütçeli planı aç →
            </a>
          </div>

          {/* ── Ölçek uyarısı ── */}
          <div className="mb-6 p-4 rounded-xl bg-rose-50 border border-rose-200">
            <p className="text-xs font-semibold text-rose-900 mb-1">
              Uyarı — bu plan Ağustos&#8217;un {(TOPLAM_BUTCE / AGUSTOS_TOPLAM.harcama).toFixed(1).replace('.', ',')} katı bütçe öngörüyor
            </p>
            <p className="text-[11px] text-rose-800 leading-relaxed">
              Ağustos&#8217;ta hesapta gerçekleşen toplam harcama <strong>{tl(AGUSTOS_TOPLAM.harcama)}</strong>. Eylül planı{' '}
              <strong>{tl(TOPLAM_BUTCE)}</strong> — yani <strong>%{Math.round(delta(TOPLAM_BUTCE, AGUSTOS_TOPLAM.harcama))}</strong> artış.
              Artışın <strong>{tl(markaButce('needoh'))}</strong>&#8217;si (%{Math.round(yuzde(markaButce('needoh'), TOPLAM_BUTCE - AGUSTOS_TOPLAM.harcama))} kadarı)
              tek bir markadan, NeeDoh&#8217;tan geliyor. Store&#8217;un kendi genel bütçesi aslında <strong>küçülüyor</strong>{' '}
              ({tl(MARKALAR[1].agustos)} → {tl(markaButce('store'))}, %{Math.round(delta(markaButce('store'), MARKALAR[1].agustos))}).
              Bu ölçekteki bir sıçramanın gerekçesi aşağıdaki NeeDoh talep bölümünde; <strong>ön koşulları</strong> ise en altta.
            </p>
          </div>

          {/* ── Eylül odağı ── */}
          <div className="mb-6 p-4 rounded-xl bg-amber-50 border border-amber-200">
            <p className="text-xs font-semibold text-amber-800 mb-1">Eylül Odağı — okul dönemi oturuyor, marka bütçeleri ayrışıyor</p>
            <p className="text-[11px] text-amber-700 leading-relaxed">
              Eylül, Store için &#8220;daha çok harca&#8221; ayı değil <strong>karma değiştirme</strong> ayı: kırtasiye ve beslenme çantası
              yükselirken çanta ve oyuncak zirvesini Ağustos&#8217;ta geçiyor. Bu yüzden Store&#8217;un genel bütçesi hafif geriliyor,
              içindeki dağılım kayıyor. Ayın asıl yeniliği <strong>marka bütçelerinin ayrışması</strong>: NeeDoh, Playmobil, Charm It,
              X Mud, Antonio Juan ve Zoo Family artık genel havuzdan değil <strong>kendi bütçelerinden</strong> yönetiliyor —
              her birinin kendi kampanyası, kendi hedef kitlesi ve kendi ölçüsü var.
            </p>
          </div>

          {/* ── Ağustos gerçekleşen → Eylül plan ── */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Ağustos 2026 Gerçekleşen → Eylül 2026 Plan (mecra bazında)</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu Harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu CPC</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu CPM</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu ROAS</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül Plan</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {['google', 'meta', 'tiktok'].map((m) => {
                    const a = AGUSTOS[m], p = mecraToplam[m], d = delta(p, a.harcama);
                    return (
                      <tr key={m}>
                        <td className="px-4 py-2 font-medium">
                          <span className="inline-flex items-center gap-2">
                            <img src={MECRA[m].logo} alt="" className="w-4 h-4 object-contain" />{MECRA[m].ad}
                          </span>
                        </td>
                        <td className={`px-4 py-2 text-right ${a.harcama ? '' : 'text-gray-400'}`}>{a.harcama ? tl(a.harcama) : '₺0 (hesap bağlı değil)'}</td>
                        <td className={`px-4 py-2 text-right ${a.cpc ? '' : 'text-gray-400'}`}>{a.cpc ? `₺${a.cpc.toFixed(2).replace('.', ',')}` : '-'}</td>
                        <td className={`px-4 py-2 text-right ${a.cpm ? '' : 'text-gray-400'}`}>{a.cpm ? tl(a.cpm) : '-'}</td>
                        <td className={`px-4 py-2 text-right font-semibold ${a.roas ? 'text-emerald-700' : 'text-gray-400'}`}>{a.roas ? a.roas.toFixed(2).replace('.', ',') : '-'}</td>
                        <td className="px-4 py-2 text-right font-semibold">{tl(p)}</td>
                        <td className={`px-4 py-2 text-right ${d === null ? 'text-blue-600' : d >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                          {a.harcama ? `${d > 0 ? '+' : ''}${Math.round(d)}%` : 'yeni'}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">{tl(AGUSTOS_TOPLAM.harcama)}</td>
                    <td className="px-4 py-2 text-right">₺{AGUSTOS_TOPLAM.cpc.toFixed(2).replace('.', ',')}</td>
                    <td className="px-4 py-2 text-right">{tl(AGUSTOS_TOPLAM.cpm)}</td>
                    <td className="px-4 py-2 text-right text-emerald-700">{AGUSTOS_TOPLAM.roas.toFixed(2).replace('.', ',')}</td>
                    <td className="px-4 py-2 text-right">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-4 py-2 text-right text-emerald-700">+{Math.round(delta(TOPLAM_BUTCE, AGUSTOS_TOPLAM.harcama))}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-blue-50 border-t border-blue-100 text-[11px] text-blue-800 leading-relaxed">
              Ağustos planı {tl(450000)} idi, gerçekleşen {tl(AGUSTOS_TOPLAM.harcama)} — <strong>%1,5 sapmayla tuttu.</strong>{' '}
              Ay boyunca <strong>{sayi(AGUSTOS_TOPLAM.donusum)} dönüşüm</strong> ve <strong>{tl(AGUSTOS_TOPLAM.ciro)} dönüşüm değeri</strong>{' '}
              raporlandı, birleşik ROAS <strong>{AGUSTOS_TOPLAM.roas.toFixed(2).replace('.', ',')}</strong>. Google tarafı ({AGUSTOS.google.roas.toFixed(2).replace('.', ',')})
              Meta tarafının ({AGUSTOS.meta.roas.toFixed(2).replace('.', ',')}) neredeyse iki katı verimde çalıştı.
              Uyarı: Ağustos planındaki {tl(25000)} TikTok bütçesi <strong>harcanmadı</strong> — hesap hâlâ bağlı değil, bu plandaki TikTok satırları da aynı riski taşıyor.
            </div>
          </div>

          {/* ══════════ MARKA BAZLI BÜTÇE ══════════ */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Marka Bazlı Bütçe Dağılımı</div>

            {/* oran şeridi — renk tek başına bilgi taşımıyor, altındaki tablo aynı veriyi yazıyla veriyor */}
            <div className="px-4 pt-4">
              <div className="flex w-full h-4 rounded-full overflow-hidden border border-gray-200 gap-[2px] bg-white">
                {MARKALAR.map((m) => (
                  <div key={m.key} style={{ width: `${yuzde(markaButce(m.key), TOPLAM_BUTCE)}%`, backgroundColor: m.renk }}
                       title={`${m.ad} ${tl(markaButce(m.key))}`} />
                ))}
              </div>
            </div>

            {/* logo kartları */}
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3 p-4">
              {MARKALAR.map((m) => (
                <div key={m.key} className="rounded-xl border bg-white p-3 flex flex-col" style={{ borderColor: m.renk + '55' }}>
                  <div className="h-9 flex items-center justify-center mb-2">
                    <img src={m.logo} alt={m.ad} className="max-h-9 max-w-full object-contain" />
                  </div>
                  <p className="text-[11px] font-medium text-gray-600 text-center truncate">{m.ad}</p>
                  <p className="text-base font-bold text-center mt-0.5" style={{ color: m.renk }}>{tl(markaButce(m.key))}</p>
                  <p className="text-[10px] text-gray-500 text-center mt-0.5">
                    %{yuzde(markaButce(m.key), TOPLAM_BUTCE).toFixed(1).replace('.', ',')} · {m.agustos ? `Ağu ${tl(m.agustos)}` : 'Ağu yok'}
                  </p>
                </div>
              ))}
            </div>

            {/* tablo — kontrast düşük renkler için okunur karşılık */}
            <div className="overflow-x-auto border-t">
              <table className="min-w-full text-[11.5px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Marka</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Google</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Meta</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">TikTok</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Feed</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Arama/ay</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {MARKALAR.map((m) => {
                    const b = markaButce(m.key), d = delta(b, m.agustos);
                    return (
                      <tr key={m.key} className="hover:bg-gray-50">
                        <td className="px-4 py-2 font-medium">
                          <span className="inline-flex items-center gap-2">
                            <span className="inline-block w-2.5 h-2.5 rounded-sm flex-shrink-0" style={{ backgroundColor: m.renk }} />
                            {m.ad}
                          </span>
                        </td>
                        <td className={`px-4 py-2 text-right ${m.agustos ? '' : 'text-gray-400'}`}>{m.agustos ? tl(m.agustos) : '-'}</td>
                        <td className="px-4 py-2 text-right font-semibold">{tl(b)}</td>
                        <td className={`px-4 py-2 text-right font-semibold ${d === null ? 'text-blue-600' : d >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                          {d === null ? 'yeni' : `${d > 0 ? '+' : ''}${Math.round(d)}%`}
                        </td>
                        <td className="px-4 py-2 text-right">{markaMecra(m.key, 'google') ? tl(markaMecra(m.key, 'google')) : '-'}</td>
                        <td className="px-4 py-2 text-right">{markaMecra(m.key, 'meta') ? tl(markaMecra(m.key, 'meta')) : '-'}</td>
                        <td className="px-4 py-2 text-right">{markaMecra(m.key, 'tiktok') ? tl(markaMecra(m.key, 'tiktok')) : '-'}</td>
                        <td className={`px-4 py-2 text-right font-medium ${m.urun === 0 ? 'text-red-600' : ''}`}>{m.urun === 0 ? '0 ürün' : `${sayi(m.urun)} ürün`}</td>
                        <td className="px-4 py-2 text-right">{sayi(m.arama)}</td>
                      </tr>
                    );
                  })}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-2.5">TOPLAM</td>
                    <td className="px-4 py-2.5 text-right">{tl(AGUSTOS_TOPLAM.harcama)}</td>
                    <td className="px-4 py-2.5 text-right">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-4 py-2.5 text-right">+{Math.round(delta(TOPLAM_BUTCE, AGUSTOS_TOPLAM.harcama))}%</td>
                    <td className="px-4 py-2.5 text-right">{tl(mecraToplam.google)}</td>
                    <td className="px-4 py-2.5 text-right">{tl(mecraToplam.meta)}</td>
                    <td className="px-4 py-2.5 text-right">{tl(mecraToplam.tiktok)}</td>
                    <td className="px-4 py-2.5 text-right">4.329</td>
                    <td className="px-4 py-2.5 text-right">-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-gray-50 border-t text-[11px] text-gray-600 leading-relaxed">
              &#8220;Feed&#8221; = 1 Eylül 2026&#8217;da Hupalupa Store kaynak ürün feed&#8217;inde (4.329 ürün, 294 marka) o markaya ait ürün sayısı.
              &#8220;Arama/ay&#8221; = markanın Türkiye&#8217;deki Google arama hacmi (Temmuz 2026). İki sütun birlikte okunur:
              yüksek arama + sıfır ürün, bütçenin harcanamayacağı anlamına gelir.
            </div>
          </div>

          {/* ══════════ NEEDOH KANIT BÖLÜMÜ ══════════ */}
          <div className="rounded-xl border-2 overflow-hidden mb-6" style={{ borderColor: '#2a78d6' }}>
            <div className="px-4 py-3 flex items-center gap-3 border-b" style={{ backgroundColor: '#2a78d612' }}>
              <img src="/logos/markalar/needoh.svg" alt="NeeDoh" className="h-9 w-auto object-contain" />
              <div>
                <p className="font-semibold text-gray-800 text-sm">Neden NeeDoh&#8217;a {tl(markaButce('needoh'))}?</p>
                <p className="text-[11px] text-gray-500">Talep 12 ayda 190 katına çıktı, bizim payımız Ağustos&#8217;ta 94 gösterim.</p>
              </div>
            </div>

            <div className="p-5">
              {/* üç sayı */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
                <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
                  <p className="text-[11px] font-medium text-blue-700">Türkiye&#8217;de aylık &#8220;needoh&#8221; araması</p>
                  <p className="text-2xl font-bold text-blue-900 mt-1">49.500</p>
                  <p className="text-[10.5px] text-blue-700 mt-1 leading-relaxed">
                    Temmuz 2026. Ağustos 2025&#8217;te <strong>260</strong> idi — <strong>190 kat</strong>. Yükseliş 8 aydır kesintisiz.
                  </p>
                </div>
                <div className="rounded-xl border border-red-100 bg-red-50 p-4">
                  <p className="text-[11px] font-medium text-red-700">Ağustos&#8217;ta bizim gösterimimiz</p>
                  <p className="text-2xl font-bold text-red-900 mt-1">94</p>
                  <p className="text-[10.5px] text-red-700 mt-1 leading-relaxed">
                    Tüm ay, 35 arama terimi, 3 tıklama. Hepsi DSA ve Branding kampanyalarına <strong>tesadüfen</strong> düştü —
                    hesapta NeeDoh kampanyası <strong>yok</strong>.
                  </p>
                </div>
                <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
                  <p className="text-[11px] font-medium text-amber-800">Feed&#8217;deki NeeDoh ürünü</p>
                  <p className="text-2xl font-bold text-amber-900 mt-1">0</p>
                  <p className="text-[10.5px] text-amber-800 mt-1 leading-relaxed">
                    4.329 ürünlük kaynak feed&#8217;de tek NeeDoh yok. Ama ana sayfada <strong>masaüstü ve mobil banner&#8217;ı var</strong> —
                    site markayı öne çıkarıyor, reklam onu göremiyor.
                  </p>
                </div>
              </div>

              {/* grafik */}
              <div className="rounded-xl border bg-white p-4 mb-4">
                <p className="text-xs font-semibold text-gray-800 mb-0.5">&#8220;needoh&#8221; — Türkiye aylık arama hacmi</p>
                <p className="text-[10.5px] text-gray-500 mb-2">Google Keyword Planner, yalnız arama ağı · Ağustos 2024 - Temmuz 2026 · tek kelime</p>
                <NeedohGrafik />
                <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2 text-[10.5px] text-gray-600">
                  <p><strong className="text-gray-900">Kıyas 1:</strong> mağazanın kendi marka araması &#8220;hupalupa&#8221; aynı ay <strong>33.100</strong>. NeeDoh ondan <strong>%50 daha büyük</strong>.</p>
                  <p><strong className="text-gray-900">Kıyas 2:</strong> bir önceki moda &#8220;pop it&#8221; <strong>6.600</strong> ve düşüyor. NeeDoh onun <strong>7,5 katı</strong>.</p>
                  <p><strong className="text-gray-900">Tek ürün:</strong> &#8220;needoh nice cube&#8221; tek başına <strong>2.400/ay</strong> — bir yıl önce 50 idi.</p>
                </div>
              </div>

              {/* mevsimsellik */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <MevsimTablosu
                  baslik="NeeDoh kategorisi Eylül&#8217;de YÜKSELİYOR"
                  satirlarVeri={MEVSIM_NEEDOH}
                  not="Duyusal oyuncak kategorisi Eylül'de iki yıl da arttı: stres oyuncağı +24%/+24%, squishy +21%/+26%, fidget +23%/0%. Düşen tek şey pop it (-19%/-18%) — yani talep eski moda üründen NeeDoh'un olduğu yere kayıyor. Uyarı: NeeDoh markasının kendi Eylül geçmişi yok (Eyl 2025'te 210 arama), o yüzden bu bütçenin gerekçesi mevsimsellik değil TREND; mevsimsellik yalnızca trendi bozmadığını gösteriyor."
                />
                <MevsimTablosu
                  baslik="Store kategorileri Ağustos → Eylül"
                  satirlarVeri={MEVSIM_STORE}
                  not="Eylül bir 'daha çok harca' ayı değil, karma değiştirme ayı: kırtasiye +22% (iki yıl da) ve beslenme çantası +83%/+82% yükselirken okul çantası -45% ve oyuncak -18% ile zirvesini Ağustos'ta geçiyor. Çanta ile kırtasiye AYNI takvime konmaz. Store'un genel bütçesinin hafif gerilemesinin sebebi bu."
                />
              </div>
            </div>
          </div>

          {/* ══════════ AMAÇ BAZLI DAĞILIM ══════════ */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya Amacına Göre Bütçe Dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200 gap-[2px] bg-white">
                <div className="bg-emerald-400" style={{ width: `${yuzde(amacToplam['Dönüşüm'], TOPLAM_BUTCE)}%` }} />
                <div className="bg-red-400" style={{ width: `${yuzde(amacToplam['Farkındalık'], TOPLAM_BUTCE)}%` }} />
                <div className="bg-pink-400" style={{ width: `${yuzde(amacToplam['Etkileşim'], TOPLAM_BUTCE)}%` }} />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Ana Mecralar</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Hedeflenen Çıktı</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">{tl(amacToplam['Dönüşüm'])}</td>
                    <td className="px-4 py-2.5 text-right">%{Math.round(yuzde(amacToplam['Dönüşüm'], TOPLAM_BUTCE))}</td>
                    <td className="px-4 py-2.5">Google PMax · Search · Shopping · DSA · Meta Advantage+ Catalog · Statik</td>
                    <td className="px-4 py-2.5">{sayi(genelTik)} satış odaklı tıklama</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">{tl(amacToplam['Farkındalık'])}</td>
                    <td className="px-4 py-2.5 text-right">%{Math.round(yuzde(amacToplam['Farkındalık'], TOPLAM_BUTCE))}</td>
                    <td className="px-4 py-2.5">Google YouTube · Meta Video Views · TikTok Awareness + Video Views</td>
                    <td className="px-4 py-2.5">{kisa(genelIzlenme)} video izlenme</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">{tl(amacToplam['Etkileşim'])}</td>
                    <td className="px-4 py-2.5 text-right">%{Math.round(yuzde(amacToplam['Etkileşim'], TOPLAM_BUTCE))}</td>
                    <td className="px-4 py-2.5">Meta Post Engagement · TikTok Engagement</td>
                    <td className="px-4 py-2.5">~{sayi(genelEtkilesim)} etkileşim</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-4 py-2.5 text-right">%100</td>
                    <td className="px-4 py-2.5">3 mecra · {PLAN.length} kampanya · 7 marka bütçesi</td>
                    <td className="px-4 py-2.5">{sayi(genelTik)} tıklama · {kisa(genelIzlenme)} izlenme · {kisa(genelGosterim)} gösterim</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-800 leading-relaxed">
              Store bir e-ticaret markası olduğu için ağırlık dönüşümde. Ağustos&#8217;a göre farkındalık payının yükselmesinin tek sebebi NeeDoh:
              tanınırlığı Türkiye&#8217;de yeni kurulan bir markada bütçenin bir kısmı zorunlu olarak talebi <em>karşılamaya</em> değil
              <em> yakalamaya</em> gidiyor. NeeDoh dışındaki tüm markalarda dönüşüm payı %85&#8217;in üzerinde.
            </div>
          </div>

          {/* ── Mecra özeti ── */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">{tl(mecraToplam.google)}</p>
              <p className="text-[10px] text-blue-600 mt-0.5">%{Math.round(yuzde(mecraToplam.google, TOPLAM_BUTCE))} • PMax + Search + Shopping + DSA + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">{tl(mecraToplam.meta)}</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">%{Math.round(yuzde(mecraToplam.meta, TOPLAM_BUTCE))} • Catalog + Statik + Etkileşim + Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">{tl(mecraToplam.tiktok)}</p>
              <p className="text-[10px] text-gray-600 mt-0.5">%{Math.round(yuzde(mecraToplam.tiktok, TOPLAM_BUTCE))} • hesap henüz bağlı değil</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Toplam Tıklama</span>
              <p className="text-xl font-bold text-emerald-800">{kisa(genelTik)}</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Ağustos gerçekleşen: {kisa(AGUSTOS_TOPLAM.tik)}</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <span className="text-xs font-medium text-red-700">Toplam İzlenme</span>
              <p className="text-xl font-bold text-red-800">{kisa(genelIzlenme)}</p>
              <p className="text-[10px] text-red-600 mt-0.5">YouTube + Meta + TikTok</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Tahmini Erişim*</span>
              <p className="text-xl font-bold text-gray-800">~{kisa(genelGosterim / 3)}</p>
              <p className="text-[10px] text-gray-600 mt-0.5">{kisa(genelGosterim)} gösterim · ort. frekans ~3,0</p>
            </div>
          </div>

          {/* Plan ↔ gerçekleşen; mecralardan canlı okunur (bkz. EylulGerceklesen).
              Aşağıdaki marka marka tablolar PLANI, bu bölüm ay içinde OLANI anlatır. */}
          <EylulGerceklesen
            brandId={BRAND_ID}
            plan={MECRA_PLANI}
            planToplam={TOPLAM_BUTCE}
            silolar={SILO_PLANI}
            kpi="revenue"
            notlar="TikTok'ta Store'un NeeDoh kampanyaları Eğlence ile paylaşılan hesapta duruyor; bu tutar kampanya adına göre süzülüp buraya eklenmiştir."
          />

          {/* ══════════ MARKA MARKA MEDYA PLANLARI ══════════ */}
          <div className="mb-2">
            <h3 className="text-base font-bold text-gray-800 mb-1">Medya Planı — marka marka</h3>
            <p className="text-[11px] text-gray-500 mb-4">
              Her tablo o markanın kendi bütçesini, kendi kampanyalarını ve kendi tahmini çıktısını gösterir.
              Birim maliyetler Ağustos 2026&#8217;da aynı hesapta gerçekleşen değerlerdir; hesapta karşılığı olmayan satırlar &#8220;pazar benchmark&#8217;ı&#8221; olarak işaretlidir.
            </p>
          </div>

          {/* Store önce, sonra bütçe büyüklüğüne göre markalar */}
          {[MARKALAR[1], ...MARKALAR.filter((m) => m.key !== 'store')].map((m) => (
            <MarkaPlanTablosu key={m.key} marka={m} />
          ))}

          {/* ══════════ MARKA SİLOSU RİSKİ ══════════ */}
          <div className="rounded-xl border border-amber-200 overflow-hidden mb-6">
            <div className="bg-amber-100 px-4 py-3 font-semibold text-amber-900 text-sm">
              Uyarı — marka bazına ayrılmış kampanyalar bu hesapta bugüne kadar daha PAHALI çalıştı
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11.5px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Ağustos 2026 kampanyası</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">CPC</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">CPM</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">ROAS</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {MARKA_IZOLE.map((k) => (
                    <tr key={k.ad} className={k.iyi ? 'bg-emerald-50' : ''}>
                      <td className="px-4 py-2 font-medium">{k.ad}</td>
                      <td className="px-4 py-2 text-right">{tl(k.harcama)}</td>
                      <td className={`px-4 py-2 text-right ${k.iyi ? 'text-emerald-700 font-semibold' : 'text-red-600 font-semibold'}`}>₺{k.cpc}</td>
                      <td className="px-4 py-2 text-right">₺{k.cpm}</td>
                      <td className={`px-4 py-2 text-right font-semibold ${k.iyi ? 'text-emerald-700' : 'text-red-600'}`}>{k.roas}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-amber-50 border-t border-amber-200 text-[11px] text-amber-900 leading-relaxed">
              Bu, planın en önemli riski ve dürüstçe söylenmesi gerekiyor: <strong>markayı kendi kampanyasına ayırmak kitleyi daraltıyor.</strong>{' '}
              Ağustos&#8217;ta marka ayrımı olmayan katalog motoru ₺2,49-3,15 CPC ile çalışıp 3,27-9,66 ROAS üretirken,
              marka bazına ayrılmış üç kampanya (Playmobil, MODU, Charm It) <strong>3-4 kat pahalı tıklama</strong> aldı ve
              ROAS&#8217;ı <strong>2-3 kat düşük</strong> kaldı. Yani bütçeyi markalara bölmek tek başına satışı artırmaz;
              düşen verimi, marka bütçesinin getirdiği <em>ek talep</em> ile telafi etmek gerekir. NeeDoh&#8217;ta bu ek talep
              ölçülebilir biçimde var (49.500 arama). Charm It (70), X Mud (10) ve Zoo Family&#8217;de (90) <strong>yok</strong> —
              o üç bütçe marka aramasına değil <strong>kategori talebine ve keşfe</strong> kurgulandı, ölçüsü de satış değil
              <strong> ilk ay için katalog keşfi</strong> olmalı.
            </div>
          </div>

          {/* ══════════ ÖN KOŞULLAR ══════════ */}
          <div className="rounded-xl border border-red-200 overflow-hidden mb-6">
            <div className="bg-red-100 px-4 py-3 font-semibold text-red-900 text-sm">
              Ön koşullar — bunlar yapılmadan planın {tl(feedSartli)}&#8217;lik kısmı yayına ALINAMAZ
            </div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[11.5px] text-gray-700">
              <div className="rounded-lg border border-red-200 bg-red-50 p-3">
                <p className="font-semibold text-red-900 mb-1">1 · NeeDoh ürünleri feed&#8217;e girmeli</p>
                <p className="leading-relaxed">
                  Kaynak feed&#8217;de (4.329 ürün) tek bir NeeDoh yok. Katalog, PMax ve katalog remarketing satırlarının
                  toplamı <strong>{tl(feedSartli)}</strong> — feed düzelmeden bu bütçe harcanamaz. Site ana sayfasında
                  NeeDoh banner&#8217;ı yayında olduğuna göre ürünler mağazada var; sorun <strong>feed&#8217;e akmaması</strong>.
                  Ayın ilk haftası içinde çözülmeli, yoksa Eylül&#8217;ün üçte biri kaybedilir.
                </p>
              </div>
              <div className="rounded-lg border border-amber-200 bg-amber-50 p-3">
                <p className="font-semibold text-amber-900 mb-1">2 · TikTok hesabı bağlanmalı</p>
                <p className="leading-relaxed">
                  Ağustos planındaki {tl(25000)} TikTok bütçesi hesap bağlı olmadığı için <strong>hiç harcanmadı</strong>.
                  Bu planda TikTok payı <strong>{tl(mecraToplam.tiktok)}</strong> ve büyük kısmı NeeDoh&#8217;a ait —
                  NeeDoh TikTok&#8217;ta doğal olarak yayılan bir ürün, mecra kapalı kalırsa markanın en verimli kanalı kaçar.
                  Bağlanmazsa bu bütçe Meta Video Views&#8217;a aktarılmalı, plandan düşülmemeli.
                </p>
              </div>
              <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                <p className="font-semibold text-gray-800 mb-1">3 · Marka bazlı ölçüm kurulmalı</p>
                <p className="leading-relaxed">
                  Bütçe marka bazında yönetilecekse <strong>raporlama da marka bazında</strong> olmalı: Google&#8217;da ürün grubu
                  ve asset grubu ayrımı, Meta&#8217;da katalog set&#8217;i, GA4&#8217;te marka boyutu. Bugün bu ayrım yalnızca
                  kampanya adında var — yani &#8220;Playmobil ne getirdi&#8221; sorusu ancak kampanya seviyesinde
                  yanıtlanabiliyor, katalog motorunun içindeki Playmobil satışı görünmüyor.
                </p>
              </div>
            </div>
          </div>

          {/* ══════════ AY İÇİ TAKVİM ══════════ */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Ay İçi Bütçe Takvimi</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                <p className="font-semibold text-gray-800 mb-1">1-10 Eylül — kurulum ve lansman (%30 · {tl(TOPLAM_BUTCE * 0.30)})</p>
                <p className="leading-relaxed">
                  NeeDoh feed&#8217;i açılır, katalog setleri kurulur, lansman kreatifleri yayına girer. Store tarafında
                  okul döneminin son dalgası (kırtasiye, beslenme çantası) sürer. Marka kampanyaları düşük bütçeyle
                  açılıp öğrenme aşamasını tamamlar — <strong>ilk 10 gün marka bütçelerinde performans beklenmez.</strong>
                </p>
              </div>
              <div className="rounded-lg border border-amber-200 bg-amber-50 p-3">
                <p className="font-semibold text-amber-800 mb-1">11-22 Eylül — ölçekleme (%40 · {tl(TOPLAM_BUTCE * 0.40)})</p>
                <p className="leading-relaxed">
                  Öğrenmesini tamamlayan marka kampanyaları tam bütçeye çıkar. NeeDoh video izleyicileri katalog
                  kampanyalarına retargeting kaynağı olur. Store&#8217;da okul kalemleri geriler, ağırlık genel katalog ve
                  hediye kategorilerine kayar. İlk verim okuması bu aralıkta yapılır.
                </p>
              </div>
              <div className="rounded-lg border border-rose-200 bg-rose-50 p-3">
                <p className="font-semibold text-rose-800 mb-1">23-30 Eylül — hasat ve devir (%30 · {tl(TOPLAM_BUTCE * 0.30)})</p>
                <p className="leading-relaxed">
                  Remarketing ağırlığı en üst seviyede. Verimi tutmayan marka bütçeleri <strong>ay içinde</strong> katalog
                  motoruna aktarılır — marka silosu bir taahhüt değil bir denemedir. Ekim&#8217;e devredilecek kitle
                  havuzları (NeeDoh video izleyicileri, katalog görüntüleyenler) burada oluşur.
                </p>
              </div>
            </div>
          </div>

          {/* ══════════ CİRO RÖNTGENİ ══════════ */}
          <CiroRontgeni markaButce={markaButce} />

          {/* ══════════ NOT ══════════ */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Projeksiyon Notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Birim maliyetler <strong>Ağustos 2026 gerçekleşen verisinden</strong> türetilmiştir — Google ₺{AGUSTOS.google.cpc.toFixed(2).replace('.', ',')} CPC / {tl(AGUSTOS.google.cpm)} CPM,
                  Meta ₺{AGUSTOS.meta.cpc.toFixed(2).replace('.', ',')} CPC / {tl(AGUSTOS.meta.cpm)} CPM. Her kampanya kendi geçmiş birim maliyetiyle projekte edilmiştir;
                  hesapta karşılığı olmayan satırlar (TikTok&#8217;un tamamı, video izlenme maliyetleri) <strong>pazar benchmark&#8217;ıdır</strong> ve tabloda öyle işaretlidir.
                  Yeni açılan marka kampanyaları için CPC, Ağustos&#8217;taki marka-izole kampanyaların gerçekleşen CPC&#8217;sinden (₺10,74-14,57) <strong>daha iyimser</strong>{' '}
                  alınmıştır (₺4-9); gerekçe bütçelerin 2-10 kat büyük olması ve ölçekle birim maliyetin düşmesidir — ancak bu bir <strong>varsayımdır</strong>, gerçekleşmezse
                  tıklama tahminleri aynı oranda geriler.
                  <strong> *Tahmini erişim</strong> platform içi tekilleştirmeye dayanır; platformlar arası çakışma ölçülemediği için tekil kişi sayısı bu rakamdan düşüktür.
                  <strong> Dönüşüm adedi ve ciro projeksiyonu bilerek verilmemiştir:</strong> NeeDoh&#8217;un Türkiye&#8217;de tek bir ay bile reklam geçmişi yok,
                  yeni açılan beş markanın hiçbirinde geçmiş ROAS verisi yok. Ağustos&#8217;ta gerçekleşen birleşik ROAS {AGUSTOS_TOPLAM.roas.toFixed(2).replace('.', ',')}&#8217;tür ve
                  hedef, bütçe {(TOPLAM_BUTCE / AGUSTOS_TOPLAM.harcama).toFixed(1).replace('.', ',')} katına çıkarken bunun <strong>3,00&#8217;ın altına düşmemesidir</strong>.
                  Arama hacimleri Google Keyword Planner&#8217;dan yalnız arama ağı için, 1 Eylül 2026&#8217;da çekilmiştir; Keyword Planner aylıkları
                  sabit kova değerleridir, mutlak sayı değil <strong>büyüklük mertebesi</strong> olarak okunmalıdır.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
